export const tr = {
    "socialMedia": {
        "facebook": "https://www.facebook.com/investturkey",
        "instagram": "https://www.instagram.com/investinturkiye_en",
        "linkedin": "https://www.linkedin.com/company/invest-in-turkey",
        "x": "https://twitter.com/InvestTurkey",
        "youtube": "https://www.youtube.com/c/InvestinT%C3%BCrkiye"
    },
    "heroSection": {
        "tagline": "2024-2028",
        "heading": "Uluslararası Doğrudan Yatırım Stratejisi",
        "description": "Bu stratejik yol haritası, küresel ekonomik ortamın hızla değiştiği bir dönemde, Türkiye’nin ekonomik kalkınma hedefleriyle uyumlu nitelikli UDY yatırımlarını ülkemize çekmeyi amaçlamaktadır."
    },
    "goals": [
        {
            "goalTag": "HEDEF 1",
            "goalHeading": "Türkiye’nin Küresel UDY Akımlarından Aldığı Payın %1,5 Seviyesine Çıkarılması",
            "goalDescription": "Stratejinin temel amacı, Türkiye’nin küresel UDY pazarından aldığı payı, nitelikli UDY profillerindeki performansını artırarak 2028 yılı itibarıyla %1,5 seviyesine çıkarmaktır.",
            "goalNumber": "1.5",
            "mathSign":"%",
            "coverImage": {
                "src": "/images/fdi-strategy-cover_1.webp",
                "alt": "DYY Strateji Kapak",
                "sizes": "(max-width: 479px) 76vw, (max-width: 767px) 320px, (max-width: 991px) 400px, 480px",
                "srcset": "/images/fdi-strategy-cover_1-p-500.png 500w, /images/fdi-strategy-cover_1fdi-strategy-cover.webp 800w, /images/fdi-strategy-cover_1fdi-strategy-cover.webp 1080w, /images/fdi-strategy-cover_1.webp 1600w"
            }
        },
        {
            "goalTag": "HEDEF 2",
            "goalHeading": "Türkiye’nin Bölgesel UDY Akımlarından Aldığı Payın %12 Seviyesine Çıkarılması",
            "goalDescription": "Türkiye, Orta ve Doğu Avrupa, Orta Doğu ve Kuzey Afrika (CEEMENA) bölgelerine yönelen UDY akımlarının %12’sini 2028 yılına kadar çekmeyi hedeflemektedir.",
            "goalNumber": "12",
            "mathSign":"%",
        },
        {
            "goalTag": "HEDEF 3",
            "goalHeading": "Her Bir Nitelikli UDY Profili Özelinde, 5 Yılda Hedeflenen Toplam Proje Sayısına Ulaşılması",
            "goalNumber": "",
            "fdiCards": [
                {
                    "iconSrc": "/images/ClimateFDI.svg",
                    "title": "İklim Dostu Yatırımlar",
                    "factNumber": "120",
                    "description": "UDY Projesi",
                    "backHeading": "Küresel Değer Zincirleri (GDZ) Yeniden Şekillendiriliyor",
                    "backDescription": "Jeopolitik gerilimler, iklim değişikliği...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/DigitalFDI.svg",
                    "title": "Dijital Yatırımlar",
                    "factNumber": "240",
                    "description": "UDY Projesi",
                    "backHeading": "Küresel Değer Zincirleri (GDZ) Yeniden Şekillendiriliyor",
                    "backDescription": "Jeopolitik gerilimler, iklim değişikliği...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/GVCRelatedFDI.svg",
                    "title": "Küresel Tedarik Zinciri (KTZ) Odaklı Yatırımlar",
                    "factNumber": "360",
                    "description": "UDY Projesi",
                    "backHeading": "Küresel Değer Zincirleri (GDZ) Yeniden Şekillendiriliyor",
                    "backDescription": "Jeopolitik gerilimler, iklim değişikliği...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/HighENDServiceFDI.svg",
                    "title": "Katma Değerli Hizmet Yatırımları",
                    "factNumber": "270",
                    "description": "UDY Projesi",
                    "backHeading": "Küresel Değer Zincirleri (GDZ) Yeniden Şekillendiriliyor",
                    "backDescription": "Jeopolitik gerilimler, iklim değişikliği...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/HighQJobFDI.svg",
                    "title": "Nitelikli İstihdam Sağlayan Yatırımlar",
                    "factNumber": "360",
                    "description": "UDY Projesi",
                    "backHeading": "Küresel Değer Zincirleri (GDZ) Yeniden Şekillendiriliyor",
                    "backDescription": "Jeopolitik gerilimler, iklim değişikliği...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                },
                {
                    "iconSrc": "/images/Knowledge-IntensiveFDI.svg",
                    "title": "Bilgi Yoğun Yatırımlar",
                    "factNumber": "300",
                    "description": "UDY Projesi",
                    "backHeading": "Küresel Değer Zincirleri (GDZ) Yeniden Şekillendiriliyor",
                    "backDescription": "Jeopolitik gerilimler, iklim değişikliği...",
                    "backImageSrc": "/images/GlobalFDI-Trend-01.webp"
                }
            ]
        }
    ],
    "policyAreasSection": {
        "tagline": "TEMEL PRENSİPLER",
        "heading": "Politika Alanları",
        "cards": [
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaee-ad92eaea",
                "href": "/action-plans#01",
                "title": "Yatırım Ortamı Rekabetçiliği"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaef-ad92eaea",
                "href": "/action-plans#02",
                "title": "Yeşil Dönüşüm"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaf3-ad92eaea",
                "href": "/action-plans#03",
                "title": "Dijital Dönüşüm"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaf7-ad92eaea",
                "href": "/action-plans#04",
                "title": "Küresel Tedarik Zinciri"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eafb-ad92eaea",
                "href": "/action-plans#05",
                "title": "Nitelikli İnsan Kaynağı"
            },
            {
                "id": "w-node-c915a300-f121-47df-acce-8975ad92eaff-ad92eaea",
                "href": "/action-plans#06",
                "title": "İletişim ve Tanıtma"
            }
        ]
    },
    "qualityFdiSlider": {
        "tagline": "UDY PROFİLLERİ",
        "heading": "Türkiye İçin Nitelikli UDY Profilleri",
        "slides": [
            {
                "id": "slide1",
                "frontImage": "/images/GlobalFDI-Trend-05_1.webp",
                "frontAlt": "İklim DYY Görseli",
                "frontNumber": "01",
                "frontTitle": "İklim Dostu Yatırımlar ",
                "backTitle": "İklim Dostu Yatırımlar ",
                "backBoldText": "İklim değişikliğinden kaynaklı risklerin yönetilmesinde, sera gazı emisyonlarının azaltılmasında ve ekonomilerin daha sürdürülebilir bir yapıya evrilmesinde yeşil dönüşüm sürecini destekleyecek uluslararası doğrudan yatırımlar önemli bir rol oynamaktadır.",
                "backImage": "/images/GlobalFDI-Trend-05_1.webp",
                "backRegularText": "Türkiye’nin iklim değişikliği ile mücadelesini ve iklim değişikliğine uyumunu destekleyecek yatırımlar, Türkiye için nitelikli UDY projeleridir. Türkiye son 10 yılda bu profilde 121 proje çekmiştir.",
                "items": [
  "Başta güneş, rüzgar, jeotermal ve yeşil hidrojen olmak üzere yenilenebilir enerji kaynaklarından enerji üreten yatırımlar",
  "Yenilenebilir enerji üretimini mümkün kılacak teknolojileri ve ürünleri geliştiren yatırımlar",
  "E-mobilite ekosistemine yönelik yatırımlar (elektrikli/hidrojenli araç ve aksamları, batarya vb.)",
  "Döngüsel ekonomiyi destekleyici yatırımlar",
  "Çevre teknolojilerinin kullanımına ve yaygınlaştırılmasına yönelik hizmet yatırımları",
  "Enerji verimliliğini artırıcı teknolojileri geliştiren ve üreten yatırımlar"
]
            },
            {
                "id": "slide2",
                "frontImage": "/images/GlobalFDI-Trend-08_1.webp",
                "frontAlt": "Dijital DYY Görseli",
                "frontNumber": "02",
                "frontTitle": "Dijital Yatırımlar ",
                "backTitle": "Dijital Yatırımlar ",
                "backBoldText": "Dijital dönüşümü destekleyici yatırımlar, birçok açıdan ülkelerin rekabetçiliğini artırmaktadır. Bu tür yatırımlar özellikle yeşil dönüşümü desteklemekte ayrıca nitelikli istihdam alanları oluşturmaktadır.",
                "backImage": "/images/GlobalFDI-Trend-08_1.webp",
                "backRegularText": "Türkiye ekonomisinin dijital dönüşümünü destekleyecek yatırımlar, Türkiye için nitelikli UDY projeleridir. Türkiye son 10 yılda bu profilde 214 proje çekmiştir.",
                "items": [
  "Yarı-iletken, elektronik parça ve bileşenler ile bilgi-iletişim sektörlerine gelen yatırımlar",
  "Elektronik ticaret, platform ekonomileri ve paylaşım ekonomileri gibi hizmet sunum kanallarının gelişimini destekleyici yatırımlar",
  "Yazılım ve oyun geliştirme sektörlerine gelen yatırımlar",
  "Ülkenin bilgi-iletişim ve internet alanındaki fiziksel altyapısını geliştirici yatırımlar (genişbant, kablolu ve kablosuz bağlantı, veri merkezi altyapısını destekleyici yatırımlar vb.)",
  "Geleneksel sektörlerin dijitalleşmesini destekleyici yatırımlar (yapay zeka, 3 boyutlu yazıcı, büyük veri analitiği, blok zinciri, bulut bilişim, siber güvenlik, nesnelerin interneti, sanal/artırılmış gerçeklik teknolojileri vb.)",
  "Eğitim, sağlık, finans sektörlerine yönelik teknolojiler ile akıllı ev uygulamalarını ve giyilebilir teknolojileri geliştiren yatırımlar"
]
            },
            {
                "id": "slide3",
                "frontImage": "/images/GlobalFDI-Trend-01.webp",
                "frontAlt": "Küresel Değer Zinciri DYY Görseli",
                "frontNumber": "03",
                "frontTitle": "KTZ Odaklı Yatırımlar ",
                "backTitle": "KTZ Odaklı Yatırımlar ",
                "backBoldText": "Küresel tedarik zincirlerine entegrasyonu yüksek sektörlerin nitelikli istihdam oluşturma, verimliliği ve ihracatı arttırma potansiyeli yüksektir. Aynı zamanda, bu tür yatırımlar yerel şirketlerle kurdukları güçlü bağlantılar sayesinde bilgi ve teknoloji transferi sağlamaktadır.",
                "backImage": "/images/GlobalFDI-Trend-01.webp",
                "backRegularText": "Türkiye’nin küresel tedarik zincirlerine entegrasyonunu artırıcı üretim, Ar-Ge ve lojistik merkezi yatırımları Türkiye için nitelikli UDY projeleridir. Türkiye son 10 yılda bu profilde 539 proje çekmiştir.",
                "items": [
                    "Otomotiv, makine ve kimya gibi orta yüksek; ilaç, havacılık, yarı iletken gibi yüksek teknolojili sektörlere gelen üretim, Ar-Ge, tasarım ve inovasyon merkezi yatırımları.",
                    "Ülkenin ulaştırma, lojistik, dağıtım ve depolama kapasitesini geliştiren altyapı yatırımları.",
                    "Sektöründen bağımsız lojistik, dağıtım ve depolama merkezi yatırımları.",
                    "Tedarik zincirlerine yönelik satın alma ofisi yatırımları."
                ]
            },
            {
                "id": "slide4",
                "frontImage": "/images/knowledge-intensive-fdi.avif",
                "frontAlt": "Bilgi Yoğun DYY Görseli",
                "frontNumber": "04",
                "frontTitle": "Bilgi Yoğun Yatırımlar ",
                "backTitle": "Bilgi Yoğun Yatırımlar ",
                "backBoldText": "Yüksek teknolojili ve bilgi yoğun alanlara yapılan yatırımlar ülkedeki mal ve hizmet ihracatının teknoloji seviyesini arttırmakta, yüksek ücretli istihdam alanları oluşturmakta ve teknoloji ekosistemini beslemektedir.",
                "backImage": "/images/knowledge-intensive-fdi.avif",
                "backRegularText": "Ülke ekonomisinin ürettiği katma değeri artıran bilgi yoğun yatırımlar, Türkiye için nitelikli UDY projeleridir. Türkiye son 10 yılda bu profilde 357 proje çekmiştir.",
                "items": [
  "STEM (fen, teknoloji, mühendislik ve matematik) alanlarında iş oluşturma potansiyeli fazla olan yüksek teknolojili sektörlere yönelik üretim yatırımları (havacılık, bilgi-iletişim ekipmanları, tıbbi cihaz, ilaç, yarı-iletkenler, yazılım ve bilgi teknolojileri hizmetleri, uzay ve savunma vb.)",
  "Sektöründen bağımsız Ar-Ge, tasarım ve inovasyon merkezi yatırımları",
  "Ülkenin bilgi-iletişim altyapısını geliştiren yatırımlar (5G ve ötesi teknolojiler, internet, veri merkezi, kablosuz iletişim projeleri vb.)",
  "Kreatif endüstrilere yönelik yatırımlar (mimari tasarım, moda tasarımı, film, eğitim içerikleri ve teknolojileri geliştirme, video oyunları vb.)",
  "Nitelikli hizmet girdilerinin sanayide kullanımını artıracak yatırımlar (yapay zeka, 3 boyutlu yazıcı, robot teknolojileri, büyük veri analitiği, blok zinciri, bulut bilişim, siber güvenlik, nesnelerin interneti, sanal/artırılmış gerçeklik teknolojiler vb.)"
]
            },
            {
                "id": "slide5",
                "frontImage": "/images/0-new-centers2_1.avif",
                "frontAlt": "Yüksek Kaliteli İş Üreten DYY Görseli",
                "frontNumber": "05",
                "frontTitle": "Nitelikli İstihdam Sağlayan Yatırımlar",
                "backTitle": "Nitelikli İstihdam Sağlayan Yatırımlar",
                "backBoldText": "Yüksek katma değerli, bilgi yoğun ve nitelikli iş alanları oluşturan yatırımların çekilmesi bir ülkenin kişi başına düşen milli gelirinin yükselmesine önemli katkılar sağlayabilmektedir.",
                "backImage": "/images/0-new-centers2_1.avif",
                "backRegularText": "Nitelikli iş alanları oluşturarak yüksek ücretli istihdam sağlayan yatırımlar, Türkiye için nitelikli UDY projeleridir. Türkiye son 10 yılda bu profilde 507 proje çekmiştir.",
                "items": [
  "Teknik eğitim merkezi, bölgesel yönetim merkezi, ortak hizmet merkezi ve teknik destek merkezi gibi hizmet yatırımları",
  "Sektöründen bağımsız Ar-Ge, tasarım ve inovasyon merkezi yatırımları",
  "STEM (fen, teknoloji, mühendislik ve matematik) alanlarında iş oluşturma potansiyeli fazla olan yüksek teknolojili sektörlere yönelik üretim yatırımları",
  "Kreatif endüstrilere yönelik yatırımlar",
  "Finansal hizmetler, bilgi-iletişim, yaşam bilimleri ve profesyonel hizmet sektörlerine gelen yatırımlar",
  "Nitelikli hizmet girdilerinin sanayide kullanımını arttıracak yatırımlar",
  "Eğitim, sağlık, finans sektörlerine yönelik teknolojiler ile akıllı ev uygulamalarını ve giyilebilir teknolojileri geliştiren yatırımlar"
]
            },
            {
                "id": "slide6",
                "frontImage": "/images/computer_1.avif",
                "frontAlt": "Üst Düzey Hizmet DYY Görseli",
                "frontNumber": "06",
                "frontTitle": "Katma Değerli Hizmet Yatırımları  ",
                "backTitle": "Katma Değerli Hizmet Yatırımları  ",
                "backBoldText": "Küresel UDY akımlarında hizmet sektörünün ağırlığı giderek artmaktadır. Ekonomide üretilen katma değerin artırılması için nitelikli hizmet üretimi önem arz etmektedir.",
                "backImage": "/images/computer_1.avif",
                "backRegularText": "Yüksek katma değer üreten nitelikli hizmet sektörü yatırımları, Türkiye için nitelikli UDY projeleridir. Türkiye son 10 yılda bu profilde 406 proje çekmiştir.",
                "items": [
  "Sektöründen bağımsız Ar-Ge, tasarım ve inovasyon merkezi yatırımları",
  "Yüksek katma değerli iş hizmetleri sektörüne gelen yatırımlar (kreatif reklamcılık, nitelikli danışmanlık, mühendislik hizmetleri, teknik eğitim, hukuk, finans ve İK danışmanlığı vb.)",
  "Nitelikli hizmet girdilerinin sanayide kullanımını arttıracak yatırımlar",
  "Bankacılık, finans ve sigorta sektörlerine gelen yatırımlar",
  "Yazılım ve oyun geliştirme sektörlerine gelen yatırımlar",
  "Bölgesel yönetim merkezi yatırımları",
  "Bakım - onarım ve teknik destek merkezi olarak faaliyet gösteren yatırımlar",
  "Ortak hizmet merkezi yatırımları"
]
            },
            {
                "id": "slide7",
                "frontImage": "/images/qualified_investment_1.avif",
                "frontAlt": "Yüksek Kaliteli Finansal DYY Görseli",
                "frontNumber": "07",
                "frontTitle": "Nitelikli Finansal Yatırımlar ",
                "backTitle": "Nitelikli Finansal Yatırımlar ",
                "backBoldText": "Nitelikli finansal yatırımlar, bir ülkenin teknoloji girişimlerinin büyümesi ve küreselleşmesi için fon sağlamakta ve girişimcilik ekosistemini besleyerek geliştirmektedir.",
                "backImage": "/images/qualified_investment_1.avif",
                "backRegularText": "Türkiye’nin sürdürülebilir kalkınmasına katkı sağlayacak finansal yatırımlar, Türkiye için nitelikli UDY projeleridir.",
                "items": [
  "Türkiye'nin teknoloji girişimciliği (start-up) ekosistemini güçlendirecek fon yatırımları",
  "Tohum fonlaması ve kitlesel fonlama gibi faaliyetlere gelen yatırımlar",
  "Melek yatırım ağını geliştirici finansal yatırımlar",
  "Girişim sermayesi yatırım fonları, özel sermaye fonları, uluslararası kalkınma finansmanı kuruluşları, aile ofisleri, varlık fonları, emeklilik fonları ve varlık yönetim şirketleri tarafından sürdürülebilir projelere yapılan yatırımlar",
  "Katılım finansmanının geliştirilmesini destekleyici yatırımlar",
  "Etki yatırımcılığı alanında yapılan finansal yatırımlar"
]
            },
            {
                "id": "slide8",
                "frontImage": "/images/Local-Economic-Cultural-Development-1_1.avif",
                "frontAlt": "Regional Development Oriented FDI Image",
                "frontNumber": "08",
                "frontTitle": "Bölgesel Kalkınmayı Destekleyen Yatırımlar  ",
                "backTitle": "Bölgesel Kalkınmayı Destekleyen Yatırımlar  ",
                "backBoldText": "Uluslararası doğrudan yatırımlar, bir ülke içerisindeki bölgelerin rekabetçiliğinin artırılmasına, küresel ekonomik entegrasyonunun güçlendirilmesine ve bölgeler arası gelişmişlik farklarının azaltılmasına yönelik önemli katkılar sunmaktadır.",
                "backImage": "/images/Local-Economic-Cultural-Development-1_1.avif",
                "backRegularText": "Türkiye’nin farklı bölgelerinin içsel potansiyelini harekete geçiren, yerelden tedarik imkanı sunan, yüksek istihdam oluşturan ve böylece bölge dışına göçü azaltan yatırımlar, Türkiye için nitelikli UDY projeleridir.",
                "backRegularSubText": "Sosyo-ekonomik Gelişmişlik Sıralaması Araştırması’na göre (SEGE) 3., 4., 5. ve 6. kademelerde yer alan illerde gerçekleştirilen;",
                "items": [
  "50 ve üstü istihdam sağlayan sanayii yatırımları",
  "İstihdam yoğun hizmet sektörü yatırımları (çağrımerkezi, lojistik ve dağıtımı merkezi vb.)",
  "Sürdürülebilir tarım ve hayvancılık faaliyetlerine yönelik yatırımlar",
  "Bölgenin turizm potansiyelini artıran ve turizm altyapısını geliştiren yatırımlar",
  "Diğer nitelikli UDY profillerine uygun tüm yatırımlar"
]
            }
        ]
    },
    "qualityFdiSection": {
        "mockupImage": "/images/mockup_reduced_1.webp",
        "mockupAlt": "FDI Mockup Görseli",
        "pdfLink": "https://www.invest.gov.tr/tr/library/publications/lists/investpublications/turkiye-uluslararasi-dogrudan-yatirim-stratejisi-2024-2028.pdf",
        "pdfLabel": "PDF İndir",
        "tagline": "TEMEL İLKELER",
        "heading": "Türkiye UDY Stratejisinin Temel Prensipleri",
        "features": [
            {
                "id": "1",
                "className": "content-features-column",
                "icon": "",
                "title": "Küresel Eğilimlerle Uyumlu",
                "description": "Küresel ekonomik dönüşüm ve Türkiye’nin ihtiyaçları dikkate alınarak DYY akışlarını etkileyebilecek trendler ayrıntılı bir şekilde analiz edilmiştir."
            },
            {
                "id": "w-node-aa06b421-a47c-8074-6cb5-f60b951b4972-951b493d",
                "className": "content-features-column",
                "icon": "",
                "title": "Sürdürülebilir Kalkınma Odaklı",
                "description": "Türkiye’nin sürdürülebilir kalkınmasına katkı sağlayacak sekiz farklı türde kalite DYY profili hassas bir şekilde tanımlanmıştır."
            },
            {
                "id": "w-node-aa06b421-a47c-8074-6cb5-f60b951b494a-951b493d",
                "className": "content-feature-item",
                "icon": "",
                "title": "Veriye Dayalı Yaklaşım",
                "description": "Her aşamada, birçok ulusal ve uluslararası veritabanına dayanan kapsamlı analizler yapılmıştır."
            },
            {
                "id": "w-node-aa06b421-a47c-8074-6cb5-f60b951b4969-951b493d",
                "className": "content-feature-item",
                "icon": "",
                "title": "UDY Alanında Ulusal Bir Yol Haritası",
                "description": "Kaliteli DYY projelerini çekmek için ulusal düzeyde tanımlanmış bir yol haritası oluşturulmuş, kurumsal çerçeve ve yönetim yapısı ayrıntılı olarak ele alınmıştır."
            },
            {
                "id": "w-node-aa06b421-a47c-8074-6cb5-f60b951b495f-951b493d",
                "className": "content-feature-item",
                "icon": "",
                "title": "Katılımcı Süreç",
                "description": "Strateji, ilgili kamu kurumları, profesyonel iş örgütleri, mevcut uluslararası yatırımcılar, akademi ve uluslararası kuruluşlar dahil olmak üzere tüm önemli paydaşların katılımıyla tasarlanmıştır."
            }
        ]
    },
    "insightsSection": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Daha Fazlasını Keşfedin",
        "tabs": [
            {
                "id": "tab1",
                "tabId": "w-node-dbdb231f-3721-ba01-b35b-fe8525f08ce7-9d204e45",
                "icon": "",
                "title": "Küresel Eğilimler ve Değerlendirmeler",
                "description": "Strateji raporunda öne çıkan küresel yatırım trendlerine genel bir bakış",
                "cards": [
                    {
                        "id": "w-node-_8de50c2f-4414-9316-7bae-0b3c7a75c0a4-9d204e45",
                        "tagline": "Küresel Eğilimler ve Değerlendirmeler",
                        "heading": "Küresel ve Bölgesel UDY Akımları",
                        "description": "Küresel ve bölgesel doğrudan yatırım hareketleri hakkında daha fazla bilgi edinin.",
                        "link": "/insights#fdi-inflows",
                        "cardId": "w-node-_8de50c2f-4414-9316-7bae-0b3c7a75c0a4-9d204e45"
                    },
                    {
                        "id": "w-node-_3cb4207e-aef5-b5ab-6667-e33bc628ab5d-9d204e45",
                        "tagline": "UDY STRATEJİSİ",
                        "className": "bento-card bg _1 w-inline-block",
                        "heading": "CEEMENA Bölgesindeki Duyurulan Yatırımlar",
                        "description": "Türkiye; gıda, tarım ve sanayi sektörlerinde CEEMENA bölgesinin en cazip yatırım destinasyonu haline gelmiştir.",
                        "link": "/insights#fdi-projects",
                        "cardId": "w-node-_3cb4207e-aef5-b5ab-6667-e33bc628ab5d-9d204e45"
                    },
                    {
                        "id": "w-node-dd0b2880-ca5c-30d7-97f9-e9d606a5c1fb-9d204e45",
                        "tagline": "UDY STRATEJİSİ",
                        "heading": "Küresel UDY’deki 8 Temel Eğilim",
                        "link": "/insights#key-trends",
                        "cardId": "w-node-dd0b2880-ca5c-30d7-97f9-e9d606a5c1fb-9d204e45",
                        "carouselClass": "content-carousel",
                        "carouselGroups": [
                            {
                                "groupClass": "content-carousel-group",
                                "images": [
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-04.webp",
                                        "alt": "Global FDI Trend 04",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-01.webp",
                                        "alt": "Global FDI Trend 01",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-07_1.webp",
                                        "alt": "Global FDI Trend 07",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-03_1.webp",
                                        "alt": "Global FDI Trend 03",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-05_1.webp",
                                        "alt": "Global FDI Trend 05",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-02_1.webp",
                                        "alt": "Global FDI Trend 02",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-06_1.webp",
                                        "alt": "Global FDI Trend 06",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-08_1.webp",
                                        "alt": "Global FDI Trend 08",
                                        "class": "icon-gigantic"
                                    }
                                ]
                            },
                            {
                                "groupClass": "content-carousel-group",
                                "images": [
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-04.webp",
                                        "alt": "Global FDI Trend 04",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-01.webp",
                                        "alt": "Global FDI Trend 01",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-07_1.webp",
                                        "alt": "Global FDI Trend 07",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-03_1.webp",
                                        "alt": "Global FDI Trend 03",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-05_1.webp",
                                        "alt": "Global FDI Trend 05",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-02_1.webp",
                                        "alt": "Global FDI Trend 02",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-06_1.webp",
                                        "alt": "Global FDI Trend 06",
                                        "class": "icon-gigantic"
                                    },
                                    {
                                        "imgSrc": "/images/GlobalFDI-Trend-08_1.webp",
                                        "alt": "Global FDI Trend 08",
                                        "class": "icon-gigantic"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "w-node-_8de50c2f-4414-9316-7bae-0b3c7a75c0b1-9d204e45",
                        "heading": "Küresel Eğilimler ve Değerlendirmeler Hakkında Daha Fazla Bilgi Edinin.",
                        "headingClassName": "h4-heading h4-read-more light",
                        "className": "bento-card color-bg w-inline-block",
                        "description": "",
                        "descriptionClassName": "description white",
                        "iconClassName": "fa-solid-span white",
                        "link": "/insights",
                        "cardId": "w-node-_8de50c2f-4414-9316-7bae-0b3c7a75c0b1-9d204e45"
                    }
                ]
            },
            {
                "id": "tab2",
                "tabId": "w-node-dbdb231f-3721-ba01-b35b-fe8525f08cf5-9d204e45",
                "icon": "",
                "title": "Türkiye’nin UDY Performansı",
                "description": "Türkiye’nin yatırım çekme kabiliyeti ve son 20 yıldaki performansına dair veriler",
                "cards": [
                    {
                        "id": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ff90-9d204e45",
                        "tagline": "TÜRKİYE’nin UDY Performansı",
                        "heading": "Mevzuat ve Temel Unsurlar",
                        "description": "Türkiye’nin güçlü UDY performansının arkasında yatan reform süreci ve temel etkenleri keşfedin.",
                        "link": "/insights#fdi-performance",
                        "cardId": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ff90-9d204e45"
                    },
                    {
                        "id": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ff9d-9d204e45",
                        "tagline": "TÜRKİYE’nin UDY Performansı",
                        "heading": "Türkiye'nin Girişimcilik Ekosistemi",
                        "className": "bento-card bg _2 w-inline-block",
                        "description": "Türkiye'nin girişimcilik ekosistemi tüm temel paydaşlara sahip olup, uluslararası yatırımcılar için dinamik bir ortam sunmaktadır.",
                        "link": "/insights#startup-ecosystem",
                        "cardId": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ff9d-9d204e45"
                    },
                    {
                        "id": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ffaa-9d204e45",
                        "tagline": "TÜRKİYE’nin UDY Performansı",
                        "heading": "UDY’nin Türkiye Ekonomisine Katkısı",
                        "description": "Doğrudan yatırımların ihracat, istihdam, teknoloji ve büyüme üzerindeki somut etkilerini inceleyin.",
                        "className": "bento-card bg icon-show w-inline-block",
                        "link": "/insights#contribution",
                        "cardId": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ffaa-9d204e45"
                    },
                    {
                        "id": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ffdb-9d204e45",
                        "className": "bento-card color-bg w-inline-block",
                        "heading": "Küresel Eğilimler ve Değerlendirmeler Hakkında Daha Fazla Bilgi Edinin.",
                        "headingClassName": "h4-heading  h4-read-more light",
                        "description": "",
                        "descriptionClassName": "description white",
                        "iconClassName": "fa-solid-span white",
                        "link": "/insights",
                        "cardId": "w-node-_3b2fafe6-098a-7068-df95-95bf8d44ffdb-9d204e45"
                    }
                ]
            },
            {
                "id": "tab3",
                "tabId": "w-node-dbdb231f-3721-ba01-b35b-fe8525f08d03-9d204e45",
                "icon": "",
                "title": "Stratejik Bulgular ve Hedefler",
                "description": "Stratejiyi şekillendiren 10 temel bulgu ve 2028 yılına kadar ulaşılması hedeflenen somut amaçlar",
                "cards": [
                    {
                        "id": "w-node-_2bda0364-020c-dc46-9fb6-134667d5306a-9d204e45",
                        "tagline": "Stratejik Bulgular ve Hedefler",
                        "heading": "Stratejiye Yön Veren 10 Temel Bulgu",
                        "description": "Stratejinin hazırlanmasında dikkate alınan eğilimler, fırsatlar ve politika ihtiyaçlarını yansıtan temel bulgular.",
                        "className": "bento-card bg key-findings w-inline-block",
                        "link": "/insights#key-findings",
                        "cardId": "w-node-_2bda0364-020c-dc46-9fb6-134667d5306a-9d204e45"
                    },
                    {
                        "id": "w-node-_2bda0364-020c-dc46-9fb6-134667d5309b-9d204e45",
                        "heading": "Küresel Eğilimler ve Değerlendirmeler Hakkında Daha Fazla Bilgi Edinin.",
                        "headingClassName": "h4-heading h4-read-more light",
                        "description": "",
                        "descriptionClassName": "description white",
                        "className": "bento-card color-bg w-inline-block",
                        "iconClassName": "fa-solid-span white",
                        "link": "/insights",
                        "cardId": "w-node-_2bda0364-020c-dc46-9fb6-134667d5309b-9d204e45"
                    },
                    {
                        "id": "w-node-_6ab104b9-9e8f-71a6-c9ef-3afbc8b2f88e-9d204e45",
                        "tagline": "Stratejik Bulgular ve Hedefler",
                        "heading": "Stratejinin Temel Hedefi ve Politika Alanları",
                        "description": "Türkiye’nin UDY alanındaki temel hedefi ile bu hedefe ulaşmak için belirlenen altı politika alanını keşfedin.",
                        "className": "bento-card bg primary-goals w-inline-block",
                        "link": "/insights#goals",
                        "cardId": "w-node-_6ab104b9-9e8f-71a6-c9ef-3afbc8b2f88e-9d204e45"
                    }
                ]
            }
        ]
    },
    "insightsHero": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Eğilimler ve Stratejik Bulgular",
        "paragraph": "Türkiye'nin Uluslararası Doğrudan Yatırım Stratejisi'ni şekillendiren eğilimler ve temel bulgulara dair kapsamlı bir genel bakış",
        "className": "cover-image insights",
        "id": "w-node-_315b066c-9375-5d43-64fe-99c0825fb648-bda32aac",
        "downloadButton": {
            "text": "PDF İndir",
            "link": "https://www.invest.gov.tr/tr/library/publications/lists/investpublications/turkiye-uluslararasi-dogrudan-yatirim-stratejisi-2024-2028.pdf"
        },
        "image": {
            "src": "/images/mockup_reduced_1.webp",
            "alt": "Görüşler Mockup Görseli",
            "srcset": "/images/mockup_reduced_1mockup_reduced.webp 500w, /images/mockup_reduced_1mockup_reduced.webp 800w, /images/mockup_reduced_1mockup_reduced.webp 1080w, /images/mockup_reduced_1.webp 1600w"
        }
    },
    "sectionIntro": {
        "icon": "",
        "tagline": "BULGULAR & ÖNGÖRÜLER",
        "heading1": "Küresel UDY Görünümü ve Temel Eğilimler"
    },
    "fdiInflows": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Küresel UDY Akımları",
        "description": "Küresel UDY akımları, 2015 ve 2016 yıllarında gerçekleşen büyük ölçekli birleşme ve satın alma projelerinden kaynaklı artışlar haricinde 2008 Küresel Finans Krizinden bu yana durağan bir görünüm sergilemektedir.",
        "downloadLink": "https://www.invest.gov.tr/en/Documents/turkiye-udy-stratejisi-2026-yili-eylem-plani.pdf?download",
        "downloadLabel": "PDF İndir",
        "cards": [
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f317-bda32aac",
                "title": "Küresel UDY’de Değişen Dinamikler: Kriz Sonrası Durgunluk, Pandemi Etkisi ve Gelişmekte Olan Ülkelerin Yükselişi",
                "description": "2008 küresel finansal krizinden bu yana küresel doğrudan yatırım akımları genel olarak durağan bir seyir izlemekte, ancak son yıllarda dikkat çekici dalgalanmalar yaşanmaktadır. COVID-19 pandemisi, 2020 yılında keskin bir düşüşe yol açmış, 2021 yılında ise birleşme ve satın alma (M&A) işlemlerinin etkisiyle geçici bir artış görülmüştür. Ancak bu toparlanma kısa ömürlü olmuş, yükselen enflasyon ve jeopolitik gerilimler küresel yatırımlarda yeniden aşağı yönlü bir eğilimi tetiklemiştir. Pandemi aynı zamanda küresel tedarik zincirlerinde dönüşüme neden olmuş; yeşil ve dijital sektörlere yönelik yatırımları hızlandırmıştır. Öte yandan, 2018’den bu yana gelişmekte olan ülkeler, gelişmiş ülkelere kıyasla daha fazla doğrudan yatırım çekmektedir. Bu eğilim 2020 sonrası dönemde de devam etmektedir."
            },
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f31e-bda32aac",
                "title": "Küresel UDY’nin Gelişmiş ve Gelişmekte Olan Ülkelere Göre Dağılımı (%)",
                "description": "",
                "imageUrl": "/images/tr/chart-3.webp"
            },
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f325-bda32aac",
                "bullets": [
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f329-bda32aac",
                        "icon": "",
                        "className": "reddish",
                        "title": "2008 Sonrası Durgunluk",
                        "description": "2015–2016’daki geçici artışlar hariç, küresel UDY’de duraklama dönemi"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f331-bda32aac",
                        "icon": "",
                        "className": "reddish",
                        "title": "Pandemi Döneminde Düşüş",
                        "description": "2020: Son 15 yılın en düşük UDY seviyesi"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f339-bda32aac",
                        "icon": "",
                        "className": "reddish",
                        "title": "2021 Yılında Sıçrama",
                        "description": "Birleşme ve satın alma (M&A) işlemlerinin etkisiyle geçici artış"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f341-bda32aac",
                        "icon": "",
                        "className": "reddish",
                        "title": "Aşağı Yönlü Seyir",
                        "description": "Korumacı önlemler ve jeopolitik gerilimlerin etkisiyle yeniden düşüş eğilimi"
                    }
                ]
            },
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f349-bda32aac",
                "bullets": [
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f34d-bda32aac",
                        "icon": "",
                        "className": "green",
                        "title": "Tedarik Zincirlerinin Yeniden Şekillenmesi",
                        "description": "Pandemi sonrası dönemde yeni yatırımlarda artış gözlemlenmiştir"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f355-bda32aac",
                        "icon": "",
                        "className": "green",
                        "title": "Yeşil ve Dijital Dönüşüm",
                        "description": "Yeşil ve dijital yatırımların yükselen trend haline gelmesi"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f35d-bda32aac",
                        "icon": "",
                        "className": "green",
                        "title": "Gelişmekte Olan Ülkelerin Yatırımda Öne Çıkışı",
                        "description": "2020’den bu yana gelişmekte olan ülkeler, gelişmiş ülkelere kıyasla daha fazla doğrudan yatırım çekmektedir"
                    },
                    {
                        "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f365-bda32aac",
                        "icon": "",
                        "className": "green",
                        "title": "Artan Eğilimler",
                        "description": "Pandemi sonrası dönemde yeşil alan (greenfield) yatırımlarında artış"
                    }
                ]
            },
            {
                "id": "w-node-_9f184bbf-542b-c142-fc2b-e1c6cb86f31e-bda32aac",
                "title": "Küresel UDY, Birleşme & Satın Alma ve Sıfırdan Yatırım Tutarları",
                "titleStrong": "(Trilyon ABD Doları)",
                "description": "",
                "imageUrl": "/images/tr/chart-2.webp"
            }
        ]
    },
    "infographicsSection": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Bölgedeki UDY Akımları",
        "description": "Orta ve Doğu Avrupa, Orta Doğu ve Kuzey Afrika’yı kapsayan CEEMENA bölgesi, 2008 Küresel Finansal Krizi sonrasında yaşanan uzun süreli durgunluğun ardından, 2015 yılından itibaren uluslararası doğrudan yatırım (UDY) akımlarında güçlü bir toparlanma sürecine girmiştir. Bölgeye gelen UDY tutarı, 2015 yılında 67,4 milyar dolarken 2023 yılında 2,6 katına çıkarak 178,3 milyar dolara ulaşmıştır. Bu gelişme, küresel ölçekte UDY hacmindeki daralmaya rağmen gerçekleşmiştir. Türkiye, bu dinamik bağlamda stratejik coğrafi konumu sayesinde uluslararası yatırımcılar açısından bölgedeki en cazip destinasyonlardan biri haline gelmiştir. Farklı sektörlerde artan yatırım ilgisiyle birlikte, yatırımcılar bölgeye yönelik yeni fırsatları değerlendirirken Türkiye’yi sıklıkla öncelikli tercih olarak konumlandırmaktadır.",
        "bulletPoints": [
            {
                "icon": "M12 4.5C16.1423 4.5 19.5 7.85775 19.5 12C19.5 16.1423 16.1423 19.5 12 19.5C7.85775 19.5 4.5 16.1423 4.5 12C4.5 7.85775 7.85775 4.5 12 4.5ZM12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6ZM12 8.25C12.7894 8.2503 13.5586 8.49973 14.198 8.96275C14.8374 9.42578 15.3144 10.0788 15.561 10.8287C15.8075 11.5787 15.8112 12.3873 15.5713 13.1394C15.3314 13.8915 14.8603 14.5488 14.2251 15.0175C13.5898 15.4862 12.8229 15.7425 12.0335 15.7498C11.2441 15.7572 10.4725 15.5152 9.82864 15.0584C9.18479 14.6016 8.70153 13.9533 8.4477 13.2057C8.19388 12.4582 8.18243 11.6497 8.415 10.8953C8.59044 11.2873 8.89521 11.6072 9.27829 11.8014C9.66138 11.9956 10.0995 12.0523 10.5195 11.9621C10.9394 11.8719 11.3156 11.6402 11.5851 11.3057C11.8546 10.9713 12.0011 10.5545 12 10.125C12.0001 9.76385 11.8959 9.41036 11.6999 9.10701C11.5039 8.80366 11.2245 8.56336 10.8953 8.415C11.2448 8.30775 11.6153 8.25 12 8.25Z",
                "title": "Stratejik Konum",
                "description": "Türkiye’nin benzersiz coğrafi avantajı"
            },
            {
                "icon": "M13.5 13.689V15.2565C12.8212 15.0165 12.0947 14.9429 11.3816 15.0418C10.6684 15.1408 9.9894 15.4094 9.40157 15.8252C8.81375 16.2409 8.33426 16.7916 8.00337 17.4311C7.67249 18.0705 7.49986 18.78 7.5 19.5L6 19.4993C5.99977 18.5834 6.20919 17.6797 6.61222 16.8573C7.01526 16.0349 7.6012 15.3157 8.32516 14.7548C9.04912 14.1939 9.89188 13.8061 10.7889 13.6212C11.6858 13.4364 12.6132 13.4593 13.5 13.6883V13.689ZM12 12.75C9.51375 12.75 7.5 10.7362 7.5 8.25C7.5 5.76375 9.51375 3.75 12 3.75C14.4862 3.75 16.5 5.76375 16.5 8.25C16.5 10.7362 14.4862 12.75 12 12.75ZM12 11.25C13.6575 11.25 15 9.9075 15 8.25C15 6.5925 13.6575 5.25 12 5.25C10.3425 5.25 9 6.5925 9 8.25C9 9.9075 10.3425 11.25 12 11.25ZM16.5 15.75V13.5H18V15.75H20.25V17.25H18V19.5H16.5V17.25H14.25V15.75H16.5Z",
                "title": "En Cazip Yatırım Noktalarından Biri",
                "description": "Yatırımcılar tarafından sıklıkla tercih edilen ülke"
            },
            {
                "icon": "M11.25 4.53749V6.80249C8.706 7.16774 6.75 9.35624 6.75 12C6.75 14.8995 9.1005 17.25 12 17.25C13.179 17.25 14.268 16.8615 15.144 16.2045L16.7467 17.8072C15.4538 18.8647 13.8 19.5 12 19.5C7.85775 19.5 4.5 16.1422 4.5 12C4.5 8.11124 7.46025 4.91324 11.25 4.53749ZM19.4625 12.75C19.3125 14.2582 18.717 15.6352 17.8073 16.746L16.2045 15.144C16.7198 14.457 17.0693 13.6395 17.1968 12.75H19.4633H19.4625ZM12.7515 4.53749C16.2945 4.88924 19.1115 7.70699 19.464 11.25H17.1975C16.869 8.95124 15.0503 7.13249 12.7515 6.80324V4.53674V4.53749Z",
                "title": "CEEMENA Bölgesinde Artan Yatırım Çekiciliği",
                "description": "Küresel UDY düşüşüne rağmen bölgesel direnç ve toparlanma"
            },
            {
                "icon": "M16.3807 14.7443L16.5128 14.877L16.6462 14.7443C16.8029 14.5876 16.989 14.4632 17.1937 14.3784C17.3985 14.2936 17.6179 14.25 17.8395 14.25C18.0611 14.25 18.2805 14.2936 18.4853 14.3784C18.69 14.4632 18.8761 14.5876 19.0328 14.7443C19.1895 14.901 19.3138 15.087 19.3986 15.2917C19.4834 15.4965 19.527 15.7159 19.527 15.9375C19.527 16.1591 19.4834 16.3785 19.3986 16.5833C19.3138 16.788 19.1895 16.974 19.0328 17.1307L16.5128 19.65L13.9943 17.1307C13.6778 16.8143 13.5 16.3851 13.5 15.9375C13.5 15.4899 13.6778 15.0607 13.9943 14.7443C14.3107 14.4278 14.7399 14.25 15.1875 14.25C15.6351 14.25 16.0643 14.4278 16.3807 14.7443ZM12 13.5V15C10.8065 15 9.66193 15.4741 8.81802 16.318C7.97411 17.1619 7.5 18.3065 7.5 19.5H6C6.00002 17.9412 6.6067 16.4436 7.6916 15.3242C8.7765 14.2049 10.2544 13.5517 11.8125 13.503L12 13.5ZM12 3.75C14.4862 3.75 16.5 5.76375 16.5 8.25C16.5004 9.4144 16.0493 10.5336 15.2416 11.3723C14.4338 12.2109 13.3323 12.7037 12.1688 12.747L12 12.75C9.51375 12.75 7.5 10.7362 7.5 8.25C7.49958 7.0856 7.95068 5.96641 8.75843 5.12774C9.56618 4.28908 10.6677 3.79629 11.8312 3.753L12 3.75ZM12 5.25C10.3425 5.25 9 6.5925 9 8.25C9 9.9075 10.3425 11.25 12 11.25C13.6575 11.25 15 9.9075 15 8.25C15 6.5925 13.6575 5.25 12 5.25Z",
                "title": "UDY Artışı",
                "description": "2015–2022 arasında bölgeye gelen yatırımların iki katına çıkması"
            }
        ],
        "downloadLink": "https://www.invest.gov.tr/en/Documents/turkiye-udy-stratejisi-2026-yili-eylem-plani.pdf?download",
        "downloadButton": "PDF İndir"
    },
    "fdiCardsSection": {
        "cards": [
            {
                "id": "w-node-a6ebe047-e62c-2f05-5b73-de940367235d-bda32aac",
                "title": "Bölgenin Küresel UDY Akımları İçindeki Payı (%)",
                "description": "2008 Küresel Finans Krizi sonrasında bölgenin küresel UDY içindeki payında belirgin bir düşüş yaşandı ve bu eğilim 2015 yılına kadar devam etti. Ancak 2015’ten itibaren, küresel ölçekte UDY hacmi daralırken bölgeye yönelik yatırımlar yeniden ivme kazandı. Bu hızlanmanın sonucunda, bölgeye yönelen toplam UDY tutarı 2015’te 67,4 milyar dolar seviyesindeyken, 2023 yılında 178,3 milyar dolara ulaşarak iki kattan fazla artış gösterdi.",
                "imageUrl": "/images/tr/chart-1.webp",
                "imageAlt": "Bölgenin Küresel UDY Akımları İçindeki Payı (%) Grafik"
            },
            {
                "id": "w-node-a6ebe047-e62c-2f05-5b73-de9403672365-bda32aac",
                "className": "dark",
                "title": "Türkiye, bölgesindeki en önemli UDY destinasyonlarından biridir.",
                "description": "Son 20 yılda (2004-2023) 261 milyar dolar UDY çeken Türkiye, %9,8’lik pazar payı ile bölgede en fazla yatırım çeken 2. ülke konumundadır.",
                "iconUrl": "/images/Star-Graph.svg",
                "imageAlt": "Yıldız Grafiği"
            }
        ]
    },
    "fdiProjectsSection": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Bölgeye Gelen Yatırım Projeleri",
        "description": "Türkiye gıda-tarım ve sanayi sektörlerindeki yatırımlar için bölgenin en önemli cazibe merkezi haline gelmiştir.",
        "downloadLink": "https://www.invest.gov.tr/en/Documents/turkiye-udy-stratejisi-2026-yili-eylem-plani.pdf?download",
        "downloadButton": "PDF İndir",
        "tabs": [
            {
                "id": "tab-1",
                "title": "Gıda ve Tarım",
                "description": "Türkiye, son 10 yılda gıda-tarım sektöründeki payını 4 katına çıkarmış ve bölgeye yönelen her beş yatırımdan birini çekmiştir.",
                "icon": "",
                "iconClass": "yellow",
                "imageUrl": "/images/tr/FoodAgriculture-Infographics.webp",
                "imageAlt": "Gıda ve Tarım Bilgi Grafiği"
            },
            {
                "id": "tab-2",
                "title": "Sanayi",
                "description": "Türkiye, son 10 yılda sanayi sektöründeki payını yaklaşık 3 katına çıkarmıştır. Bu başarıda, otomotiv, makine, kimya gibi küresel tedarik zincirine entegre sektörlerde çekilen imalat sanayii yatırımları büyük rol oynamıştır.",
                "icon": "",
                "iconClass": "turqoise",
                "imageUrl": "/images/tr/Industry-Infographics.webp",
                "imageAlt": "Endüstri Bilgi Grafiği"
            },
            {
                "id": "tab-3",
                "title": "Hizmetler",
                "description": "Türkiye, son 10 yılda hizmet sektörüne çektiği proje sayısını korumuş olmasına rağmen bölgesel payında bir miktar düşüş gerçekleşmiştir.",
                "icon": "",
                "iconClass": "brown",
                "imageUrl": "/images/tr/Service-Infographics.webp",
                "imageAlt": "Hizmetler Bilgi Grafiği"
            }
        ],
        "sourceInfo": "fDi Markets, 2024 & Yatırım Ofisi Analizleri"
    },
    "keyOutcomes": {
        "slides": [
            {
                "id": "slide-1",
                "keyInfoId": "w-node-_98fdce91-a221-1bc4-6d3d-37bb983c9b54-bda32aac",
                "contentWrapperId": "w-node-_98fdce91-a221-1bc4-6d3d-37bb983c9b63-bda32aac",
                "title": "İMALAT PROJELERİNDEKİ BÖLGESEL PAY ARTIŞI",
                "fact": "<span class='number-fact'>4.5</span> KAT",
                "footer": "<strong>2014-2023:</strong><br>Bir Önceki 10 Yıla Göre",
                "description": {
                    "heading": "FAALİYET TÜRÜNE GÖRE BÖLGEDE DUYURULAN YATIRIMLAR",
                    "content": "Bölgede yapılacağı duyurulan yatırımların faaliyet türü bakımından dağılımı incelendiğinde, imalat, Ar-Ge ve Ortak Hizmet Merkezi (OHM) projeleri pandemi sonrası dönemdeki artışlarıyla dikkat çekmektedir. Özellikle OHM projeleri son 3 yılda yaklaşık 2,5 katına çıkarak rekor kırmıştır.",
                    "highlight": "Türkiye, imalat projelerinde bölgesinin açık ara lider ülkesidir.",
                    "details": "Türkiye, 2014-2023 döneminde, bir önceki 10 yıllık döneme göre, imalat projelerinde bölgesel payını 4,5 katına çıkararak bölgeye yönelen imalat yatırımlarının %22'sini çekmeyi başarmıştır ve bölgesinin açık ara lider ülkesi olmuştur. Bununla birlikte, Ar-Ge projelerindeki bölgesel payını ise arttırmıştır."
                }
            },
            {
                "id": "slide-2",
                "keyInfoId": "w-node-_98fdce91-a221-1bc4-6d3d-37bb983c9b72-bda32aac",
                "contentWrapperId": "w-node-_98fdce91-a221-1bc4-6d3d-37bb983c9b87-bda32aac",
                "title": "BİRLEŞME VE SATIN ALMA TÜRÜ YATIRIMLARDA BÖLGESİNDE",
                "fact": "<span class='number-fact'>2.</span> <br/>ÜLKE<br>",
                "footer": "<strong>2004-2023:</strong><br>Proje Sayısına Göre",
                "description": {
                    "heading": "BÖLGEDEKİ BİRLEŞME VE SATIN ALMA TÜRÜ YATIRIMLAR",
                    "content": "Orta ve Doğu Avrupa, Orta Doğu ve Kuzey Afrika bölgeleri, sıfırdan yatırımların yanında birleşme ve satın alma yatırımları için de dünyanın önde gelen destinasyonlarından biridir. Pandemi sonrasında, dünya genelinde yapılan birleşme ve satın alma yatırımlarının (hem proje sayısına hem de yatırım tutarına göre) yaklaşık %7'si bu bölgeye gelmiştir.",
                    "highlight": "Türkiye, birleşme ve satın alma türü yatırımlarda bölgesinin en fazla yatırım çeken 2. ülkesi konumundadır.",
                    "details": "Türkiye, son 20 yılda bölgede gerçekleşen birleşme ve satın alma türü yatırımların %8,3'ünü (proje sayısına göre) çekmiştir."
                }
            },
            {
                "id": "slide-3",
                "keyInfoId": "w-node-_330a69f9-c3c3-7b8d-a818-b9162e580f7d-bda32aac",
                "contentWrapperId": "w-node-_330a69f9-c3c3-7b8d-a818-b9162e580f8c-bda32aac",
                "title": "SIFIRDAN YATIRIMLARDA BÖLGESİNDE",
                "fact": "<span class='number-fact'>3.</span><br>ÜLKE",
                "footer": "<strong>2014-2023:</strong><br>Proje Sayısına Göre",
                "description": {
                    "heading": "BÖLGEDE DUYURULAN SIFIRDAN YATIRIMLAR",
                    "content": "Bölgede duyurulan yatırım projelerinin sayısı, Küresel Finans Krizi sonrasında önemli ölçüde azalmış ve pandemiye kadar yatay bir görünüm sergilemiştir. Fakat pandemi sonrasında hızla toparlanarak son 20 yılın en yüksek seviyesine ulaşmıştır. 2023 yılında duyurulan sıfırdan yatırım projelerinin sayısı pandemi öncesine göre %75 oranında artmıştır.",
                    "highlight": "Türkiye, sıfırdan yatırımlarda bölgesinin en fazla yatırım çeken ülkelerinden biridir.",
                    "details": "Türkiye, 2014-2023 döneminde, bir önceki 10 yıllık döneme göre, sıfırdan yatırımlarda bölgeden aldığı payı arttırarak bölgesinin en fazla sıfırdan yatırım çeken 3 ülkesinden biri olmuştur."
                }
            },
            {
                "id": "slide-4",
                "keyInfoId": "w-node-a1c8d248-9cd8-03a7-57ee-8971955b7daa-bda32aac",
                "contentWrapperId": "w-node-a1c8d248-9cd8-03a7-57ee-8971955b7dc1-bda32aac",
                "title": "GENİŞLEME TÜRÜ YATIRIMLARDAKİ ARTIŞ",
                "fact": "<span class='number-fact'>5</span> KAT",
                "footer": "<strong>2014-2023:</strong><br>Bir Önceki 10 Yıla Göre",
                "description": {
                    "heading": "BÖLGEDE DUYURULAN GENİŞLEME TÜRÜ YATIRIMLAR",
                    "content": "Bölgede duyurulan genişleme türü yatırım projelerinin sayısı son 10 yılda genel olarak artış trendindedir. Genişleme türü yatırımların sayısı pandemi öncesine göre 2022 yılında %61, 2023 yılında ise %34 oranında artmıştır.",
                    "highlight": "Türkiye, genişleme türü yatırımlarda bölgesinin açık ara lider ülkesidir.",
                    "details": "Türkiye, 2014-2023 döneminde, bir önceki 10 yıllık döneme göre, genişleme türü yatırımlardaki payını yaklaşık 5 katına çıkarmıştır. %3,9'dan %19,7'e ulaşan payı ile Türkiye, genişleme türü yatırımlarda bölgesinin açık ara lider ülkesi olmuştur. Bu durum, Türkiye'nin iş ve yatırım ortamını deneyimlemiş şirketlerin bölgedeki operasyonlarını büyütmek ve değer zincirlerini güçlendirmek için yine Türkiye'yi seçtiğini göstermektedir."
                }
            }
        ]
    },
    "fdiTrends": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Küresel UDY Alanında 8 Temel Eğilim",
        "description": "Küresel UDY dinamikleri önemli bir dönüşüm sürecinden geçmektedir. Yatırımcı kararları her geçen gün daha fazla sekiz temel eğilim tarafından şekillendirilmektedir. Bu eğilimlerin derinlemesine anlaşılması, Türkiye’nin ulusal UDY stratejisinin etkili şekilde tasarlanması ve uygulanması açısından tüm paydaşlar için kritik önemdedir.",
        "downloadText": "PDF İndir",
        "pdfLink": "https://www.invest.gov.tr/en/Documents/turkiye-udy-stratejisi-2026-yili-eylem-plani.pdf?download",
        "flipCards": [
            {
                "id": "trend-01",
                "frontImage": "/images/GlobalFDI-Trend-01.webp",
                "frontAlt": "Küresel Tedarik Zincirleri Yeniden Şekilleniyor",
                "frontNumber": "01",
                "frontTitle": "Küresel Tedarik Zincirleri Yeniden Şekilleniyor",
                "frontDescription": "",
                "backTitle": "Küresel Tedarik Zincirleri Yeniden Şekilleniyor",
                "backBoldText": "Jeopolitik gerilimler, iklim değişikliği ve doğal afetler, salgın hastalıklar ile sürdürülebilirlik ve dijitalleşme kavramlarının artan önemi küresel tedarik zincirlerinin yeniden kurgulanmasına sebep olmaktadır.",
                "backImage": "/images/GlobalFDI-Trend-01.webp",
                "backRegularText": "",
                "frontTagline": "UDY EĞİLİMLERİ"
            },
            {
                "id": "trend-02",
                "frontImage": "/images/GlobalFDI-Trend-02_1.webp",
                "frontAlt": "Tersine Küreselleşme ve Korumacılık Eğilimleri Güçleniyor",
                "frontNumber": "02",
                "frontTitle": "Tersine Küreselleşme ve Korumacılık Eğilimleri Güçleniyor",
                "frontDescription": "",
                "backTitle": "Tersine Küreselleşme ve Korumacılık Eğilimleri Güçleniyor",
                "backBoldText": "Son dönemde küresel ekonomik güçler arasında yaşanan gerilimler, ülkelerin ulusal güvenlik endişesiyle yatırım ve ticaret alanlarında daha korumacı ve içe kapanmacı bir tutum sergilemesine neden olmaktadır.",
                "backImage": "/images/GlobalFDI-Trend-02_1.webp",
                "backRegularText": "",
                "frontTagline": "UDY EĞİLİMLERİ"
            },
            {
                "id": "trend-03",
                "frontImage": "/images/GlobalFDI-Trend-03_1.webp",
                "frontAlt": "Küresel Makroekonomik Gelişmelerdeki Belirsizlikler Artıyor",
                "frontNumber": "03",
                "frontTitle": "Küresel Makroekonomik Gelişmelerdeki Belirsizlikler Artıyor",
                "frontDescription": "",
                "backTitle": "Küresel Makroekonomik Gelişmelerdeki Belirsizlikler Artıyor",
                "backBoldText": "Küresel Finans Krizini izleyen yıllarda, dünya genelinde ekonomik aktivitedeki verimliliğin azalması, ekonomilerin düşük oranlı büyüme performansları ve özellikle pandemi sürecinde özel sektörün ve hane halklarının desteklenmesi gibi faktörler neticesinde maliye ve para politikalarında gevşeme yaşanmıştır.",
                "backImage": "/images/GlobalFDI-Trend-03_1.webp",
                "backRegularText": "",
                "frontTagline": "UDY EĞİLİMLERİ"
            },
            {
                "id": "trend-04",
                "frontImage": "/images/GlobalFDI-Trend-04.webp",
                "frontAlt": "Küresel Düzlemde Ekonomik ve Politik Ayrılıklar Derinleşiyor",
                "frontNumber": "04",
                "frontTitle": "Küresel Düzlemde Ekonomik ve Politik Ayrılıklar Derinleşiyor",
                "frontDescription": "",
                "backTitle": "Küresel Düzlemde Ekonomik ve Politik Ayrılıklar Derinleşiyor",
                "backBoldText": "Küresel düzlemde yaşanan ekonomik ve politik ayrılıklar, bunun sonucunda giderek artan korumacı ve kısıtlayıcı uygulamalar, küresel ekonomiyi etkileyen önemli bir olgu olarak belirmeye başlamıştır. IMF, Dünya Bankası, UNCTAD ve OECD gibi uluslararası kuruluşların raporları, bu tür jeopolitik eğilimlerin halihazırda uluslararası doğrudan yatırımları ve finansal yatırımları ciddi biçimde etkilemeye başladığına ve yatırımların yöneleceği destinasyonları etkilediğine işaret etmektedir.",
                "backImage": "/images/GlobalFDI-Trend-04.webp",
                "backRegularText": "",
                "frontTagline": "UDY EĞİLİMLERİ"
            },
            {
                "id": "trend-05",
                "frontImage": "/images/GlobalFDI-Trend-05_1.webp",
                "frontAlt": "İklim Değişikliği ve Çevresel Sürdürülebilirlik Dönüştürücü Bir Rol Oynuyor",
                "frontNumber": "05",
                "frontTitle": "İklim Değişikliği ve Çevresel Sürdürülebilirlik Dönüştürücü Bir Rol Oynuyor",
                "frontDescription": "",
                "backTitle": "İklim Değişikliği ve Çevresel Sürdürülebilirlik Dönüştürücü Bir Rol Oynuyor",
                "backBoldText": "İklim değişikliğinin etkilerinin azaltılması ve iklim değişikliğine uyum konuları son yıllarda özel sektörün ve politika yapıcıların en kritik gündem maddelerinden biri haline gelmiştir. Paris İklim Anlaşması ve AB Yeşil Mutabakatı gibi küresel ve bölgesel iklim politikalarının da etkisiyle çevresel sürdürülebilirlik kavramının önemi giderek artmakta, bu durum UDY akımlarını derinden etkilemektedir.",
                "backImage": "/images/GlobalFDI-Trend-05_1.webp",
                "backRegularText": "",
                "frontTagline": "UDY EĞİLİMLERİ"
            },
            {
                "id": "trend-06",
                "frontImage": "/images/GlobalFDI-Trend-06_1.webp",
                "frontAlt": "Dijital Dönüşüm Hızlanıyor",
                "frontNumber": "06",
                "frontTitle": "Dijital Dönüşüm Hızlanıyor",
                "frontDescription": "",
                "backTitle": "Dijital Dönüşüm Hızlanıyor",
                "backBoldText": "Dijitalleşme sürecinin küresel düzeyde hız kazanması, geleneksel sektörleri güçlü bir şekilde dönüştürürken birçok yeni sektörü de ortaya çıkarmaktadır.",
                "backImage": "/images/GlobalFDI-Trend-06_1.webp",
                "backRegularText": "",
                "frontTagline": "UDY EĞİLİMLERİ"
            },
            {
                "id": "trend-07",
                "frontImage": "/images/GlobalFDI-Trend-07_1.webp",
                "frontAlt": "Bölgesel ve Ulusal Sanayi Politikaları Ağırlık Kazanıyor",
                "frontNumber": "07",
                "frontTitle": "Bölgesel ve Ulusal Sanayi Politikaları Ağırlık Kazanıyor",
                "frontDescription": "",
                "backTitle": "Bölgesel ve Ulusal Sanayi Politikaları Ağırlık Kazanıyor",
                "backBoldText": "Devletlerin yeniden hedef odaklı sanayi politikaları geliştirmesi, 2008 Küresel Finans Krizi ile başlayan ve dünyadaki jeopolitik gerilimlerin artmasıyla hızlanan bir fenomen haline gelmiştir. Birçok küresel aktör stratejik sektörlerde yeni sanayi politikaları ile kapsamlı teşvik paketleri tasarlamaktadır.",
                "backImage": "/images/GlobalFDI-Trend-07_1.webp",
                "backRegularText": "",
                "frontTagline": "UDY EĞİLİMLERİ"
            },
            {
                "id": "trend-08",
                "frontImage": "/images/GlobalFDI-Trend-08_1.webp",
                "frontAlt": "Yeni Teknolojiler ve Nitelikli Hizmet Girdileri İmalat Sanayiini Dönüştürüyor",
                "frontNumber": "08",
                "frontTitle": "Yeni Teknolojiler ve Nitelikli Hizmet Girdileri İmalat Sanayiini Dönüştürüyor",
                "frontDescription": "",
                "backTitle": "Yeni Teknolojiler ve Nitelikli Hizmet Girdileri İmalat Sanayiini Dönüştürüyor",
                "backBoldText": "Yapay zekâ destekli otomasyon sistemleri, robotik ve üç boyutlu yazıcı gibi teknolojilerin yaygınlaşması imalat sanayiini hızla dönüştürmektedir. Üretim süreçlerinde yaşanan bu dönüşüm, özellikle emek yoğun sektörlerdeki yatırım çekme rekabetinde işgücü maliyetlerinin önemini azaltmıştır. Buna karşın birçok sektörde dijital becerileri gelişmiş nitelikli işgücüne erişim, uluslararası yatırımcılar için daha önemli hale gelmektedir.",
                "backImage": "/images/GlobalFDI-Trend-08_1.webp",
                "backRegularText": "",
                "frontTagline": "UDY EĞİLİMLERİ"
            }
        ]
    },
    "fdiPerformance": {
        "id": "fdi-performance",
        "header": {
            "icon": "<span class='fontawesome'></span>",
            "tagline": "",
            "heading": "Türkiye'nin UDY Performansı",
             "description":"Türkiye, son 20 yılda gerçekleştirdiği reformlar, sahip olduğu ekonomik ve siyasi istikrar, genç ve dinamik nüfus yapısı, jeostratejik konumu vb. pek çok unsur sayesinde UDY alanında büyük ivme yakalamıştır."
        },
        "cards": [
            {
                "id": "w-node-a3d0e202-8c68-27c1-4f72-91fb61149c02-bda32aac",
                "title": "Ekonomik Kalkınma için Yeni Yasal Düzenlemeler, Çağa Uygun Reformlar",
                "content": "<blockquote>Doğrudan Yabancı Yatırımlar Kanunu</blockquote> <blockquote>Kapsamlı Destek ve Teşvikler</blockquote> <blockquote>Sürdürülebilirlik ve Yeşil Dönüşüm</blockquote> <blockquote>Yatırım Ortamını İyileştirme Koordinasyon Kurulu (YOİKK)</blockquote> <blockquote>Cumhurbaşkanlığı Yatırım Ofisinin Kurulması</blockquote> <blockquote>Temel Kanunlarda Yapılan Reformlar</blockquote> <blockquote>Yargı Alanında Yatırım Ortamını İyileştirici Reformlar</blockquote> <blockquote>Dünya Bankası İş Yapma Kolaylığı Endeksi Çalışmaları</blockquote>"
            },
            {
                "id": "w-node-_9597edd6-e4a9-c1c1-94ed-00f8328a69e7-bda32aac",
                "title": "Türkiye'nin UDY Performansının Altında Yatan Temel Faktörler",
                "content": "<ul> <li>Ekonomik ve Siyasi İstikrar</li> <li>Küresel Krizlere Karşı Dayanıklı Ekonomi</li> <li>Genç ve Dinamik Nüfus</li> <li>Nitelikli İşgücü</li> <li>Altyapı Yatırımları</li> <li>Dijitalleşme</li> <li>Ar-Ge Ekosistemi</li> <li>Jeostratejik Konum</li> <li>Serbest Ticaret Anlaşmaları ve Gümrük Birliği</li> <li>Küresel Değer Zincirlerine Entegrasyon</li> <li>Ekonomik Büyüme</li> <li>Üretim ve İhracat Üssü</li> </ul>"
            }
        ],
        "statisticsCard": {
            "id": "w-node-_9909d3a2-4e8e-300a-e2aa-d73a9ab7a136-bda32aac",
            "title": "UDY PASTASINDAN TÜRKİYE'NİN ALDIĞI PAY",
            "statistics": "<div class=\"content-statistics\"> <div id=\"w-node-d16f4fcd-8b7b-f70d-af48-881525d25db5-bda32aac\" class=\"stats-grid\"> <div class=\"h6-heading yellow\">TOPLAM UDY*</div> <div class=\"counter-wrap grayscale\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"15\" fb-count-time=\"3000\" class=\"stat-heading\">15 Milyar $</div> <div class=\"counter-text\">1973 - 2002</div> </div> <div class=\"counter-wrap\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"262\" fb-count-time=\"3000\" class=\"stat-heading\">262 Milyar $</div> <div class=\"counter-text\">2003 - 2023</div> </div> </div> <div id=\"w-node-_82370bea-b0d8-eeb3-94c3-608f24aff697-bda32aac\" class=\"stats-grid\"> <div class=\"h6-heading yellow\">UDY PASTASINDAN TÜRKİYE'NİN ALDIĞI PAY*</div> <div class=\"counter-wrap grayscale\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"0.2\" fb-count-time=\"3000\" class=\"stat-heading\">% 0,2</div> <div class=\"counter-text\">1990-2002</div> </div> <div class=\"counter-wrap\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"0.9\" fb-count-time=\"3000\" class=\"stat-heading\">% 0,9</div> <div class=\"counter-text\">2003-2023</div> </div> </div> <div id=\"w-node-_920ce171-c107-880f-e275-3450d4bb76d8-bda32aac\" class=\"stats-grid\"> <div class=\"h6-heading yellow\">TÜRKİYE'DE FAALİYET GÖSTEREN ULUSLARARASI SERMAYELİ ŞİRKET SAYISI</div> <div class=\"counter-wrap grayscale\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"5600\" fb-count-time=\"3000\" class=\"stat-heading\">5.600</div> <div class=\"counter-text\">2003</div> </div> <div class=\"counter-wrap\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"82700\" fb-count-time=\"3000\" class=\"stat-heading\">82.700</div> <div class=\"counter-text\">2023</div> </div> </div> <div id=\"w-node-_569286b7-76cb-3339-be86-7ec56e19a0f7-bda32aac\" class=\"stats-grid\"> <div class=\"h6-heading yellow\">ÇEKİLEN UDY'NİN CARİ DENGEYE ORTALAMA KATKISI</div> <div class=\"counter-wrap\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"40\" fb-count-time=\"3000\" class=\"stat-heading\">% 40</div> <div class=\"counter-text\">2003-2023</div> </div> </div> </div>"
        }
    },
    "startupEcosystem": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Türkiye Teknoloji Girişimi Ekosistemi",
        "description": "Türkiye sağlıklı bir girişimcilik ekosisteminde bulunması gereken tüm paydaşlara sahip durumdadır. Son yıllarda teknoloji girişimlerine (start-up) yapılan yatırımlar UDY akımlarında önemli bir yer tutmaya başlamıştır. Türkiye, güçlü bir girişimcilik kültürünün varlığı, genç, dinamik ve geniş yetenek havuzu ile gerçekleştirilen reformlar sayesinde teknoloji girişimciliği alanında bölgesinde ön plana çıkmaktadır.",
        "pdfLink": "https://www.invest.gov.tr/en/Documents/turkiye-udy-stratejisi-2026-yili-eylem-plani.pdf?download",
        "buttonText": "PDF İndir",
        "content":[  "GİRİŞİM SERMAYESİ FONLARI",
  "MELEK YATIRIM AĞLARI",
  "ÖZEL SERMAYE FONLARI",
  "TEKNOPARKLAR",
  "KULUÇKA MERKEZLERİ",
  "KİTLESEL FONLAMA",
  "TOHUM FONLAMA",
  "HIZLANDIRMA MERKEZLERİ",
  "KAMU DESTEKLERİ"],
        "cards": [
            {
                "id": "w-node-b7006ced-f850-0673-fd0f-76ed306bf935-bda32aac",
                "heading": "TÜRKİYE’DE ERKEN AŞAMA YATIRIM RAKAMLARI 2010 - 2023",
                "description": "Erken aşama yatırımlarda, 2010 – 2020 yılları arasında yıllık ortalama 104 işlem üzerinden 74 milyon dolarlık yatırım çeken Türkiye’nin girişim ekosistemi, 2021-2023 yılları arasında tarihi zirvelerine ulaşarak yıllık ortalama 338 işlem aracılılığıyla 1,33 milyar dolarlık yatırım çekmiştir.",
                "image": "/images/tr/EN-FDI-Strategy-Report_2.webp",
                "alt": "Startup Ecosystem Image"
            },
            {
                "id": "w-node-b7006ced-f850-0673-fd0f-76ed306bf93c-bda32aac",
                "heading": "UNICORN SEVİYESİNE ULAŞAN GİRİŞİM SAYISI",
                "description": "2020-2023",
                "number": "5"
            },
            {
                "id": "w-node-c96aa4eb-355c-cee6-1fb6-1d84c63953dc-bda32aac",
                "heading": "DECACORN SEVİYESİNE ULAŞAN GİRİŞİM SAYISI",
                "description": "2020-2023",
                "number": "2"
            }
        ]
    },
    "contributionSection": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "UDY’nin Türkiye Ekonomisine Katkısı",
        "description": "Türkiye’ye gelen UDY, sadece cari açığın finansmana destek olmakla kalmamış; aynı zamanda, uluslararası sermaye ile kurulan şirketlerin ülkemizde yürüttüğü faaliyetler sayesinde reel ekonominin gelişimine de önemli katkılar sunmuştur",
        "source": "<strong>Kaynak:</strong> Girişimci Bilgi Sistemi (GBS) & Yatırım Ofisi Analizleri",
        "tabs": [
            {
                "id": "employment",
                "iconClass": "yellow",
                "icon": "",
                "heading": "İstihdam",
                "content": "<div id=\"w-node-_02c9d632-bf27-911c-c94e-583f1e56e75e-bda32aac\" class=\"tab-bento-card\"> <div class=\"bento-card-header gap20\"> <div id=\"w-node-_78da1cfc-2e04-5e0f-4e01-b04d2a9e0574-bda32aac\" class=\"stats-grid\"> <div class=\"h6-heading yellow\">İstihdam</div> <div class=\"counter-wrap grayscale\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"500000\" fb-count-time=\"3000\" class=\"stat-heading\">500 Bin Kişi</div> <div class=\"counter-text\">2006</div> </div> <div class=\"counter-wrap\"> <div fb-count-delay=\"800\" fb-count=\"true\" fb-count-target=\"1320000\" fb-count-time=\"3000\" class=\"stat-heading\">1 Milyon 320 Bin Kişi</div> <div class=\"counter-text\">2021</div> </div> </div> <div id=\"w-node-_1eed080e-8ab4-37d1-ed55-d6ca9bf9dce7-bda32aac\" class=\"stats-grid gap20\"> <div id=\"w-node-_33ca0750-6a3e-5dca-d9d3-4217311f3170-bda32aac\" class=\"h6-heading yellow\"><strong>TOPLAM ÖZEL SEKTÖR İSTİHDAMI İÇERİSİNDEKİ PAY</strong></div> <img sizes=\"218.515625px\" srcset=\"/images/tr/66b76e2728b4fd5accfce313_Employment-Rate-p-500.webp 500w, /images/tr/66b76e2728b4fd5accfce313_Employment-Rate-p-500.webp 874w\" alt=\"\" src=\"/images/tr/66b76e2728b4fd5accfce313_Employment-Rate-p-500.webp\" loading=\"lazy\" class=\"stat-graph _400px\"> <p class=\"description\">Uluslararası sermayeli şirketlerin 2006 yılındaki kayıtlı istihdamı 500 bin kişi seviyelerinde iken 2021'de 1 milyon 320 bine ulaşmıştır. Bu şirketlerin, Türkiye'deki toplam kayıtlı istihdam içerisindeki payı ise 2006 yılında %7,6'dan 2021 yılında %8,8'e yükselmiştir.</p> </div> </div> </div>"
            },
            {
                "id": "exports",
                "iconClass": "turqoise",
                "icon": "",
                "heading": "İhracat",
                "content": "<div id=\"w-node-cc6eb5a8-0dfa-319c-c4b5-c78e87172e80-bda32aac\" class=\"tab-bento-card\"> <div class=\"bento-card-header gap0\"> <div class=\"stats-grid grid no-border\"> <div id=\"w-node-e420dc75-08be-1f26-11e6-acdb03959688-bda32aac\" class=\"h6-heading yellow\"><strong>ULUSLARARASI SERMAYELİ ŞİRKETLERİN PAYI</strong></div> <img loading=\"lazy\" src=\"/images/tr/FDI-Strategy-Report-Export.webp\" alt=\"\" class=\"stat-graph\"> <p class=\"description\">2006-2021 döneminde Türkiye'nin toplam ihracatının yaklaşık %31'i uluslararası sermayeli şirketler tarafından yapılmıştır.</p> </div> <div class=\"stats-grid grid\"> <div> <h5 class=\"h6-heading turqoise right-aligned\"><span class=\"stat-heading\">2,5</span> KAT<br>ARTIŞ</h5> </div> <p class=\"description\">Uluslararası sermayeli şirketlerin ihracatı 2006 yılında 25 milyar dolar seviyelerinde iken 2021 yılında 63 milyar doların üzerine çıkmıştır.</p> </div> <div class=\"stats-grid grid\"> <div> <h5 class=\"h6-heading turqoise right-aligned\"><span class=\"stat-heading\">%61</span> ORTA-YÜKSEK<br>VE YÜKSEK TEKNOLOJİ</h5> </div> <p class=\"description\">2006-2021 döneminde, uluslararası sermayeli şirketlerce yapılan ihracatın %61'i orta-yüksek ve yüksek teknolojili ürünlerden oluşmaktadır. Bu oran, Türkiye ortalamasının üzerindedir.</p> </div> </div> </div>"
            },
            {
                "id": "rnd",
                "iconClass": "brown",
                "icon": "",
                "heading": "Ar-Ge",
                "content": "<div id=\"w-node-_9d167489-4fae-9d43-6d1a-8502651eee1c-bda32aac\" class=\"tab-bento-card\"> <div class=\"bento-card-header gap0\"> <div class=\"stats-grid grid no-border\"> <div id=\"w-node-_9d167489-4fae-9d43-6d1a-8502651eee1f-bda32aac\" class=\"h6-heading yellow\"><strong>ULUSLARARASI SERMAYELİ ŞİRKETLERİN PAYI</strong></div> <img sizes=\"100vw\" srcset=\"/images/tr/RnD-Stats.webp 500w, /images/tr/RnD-Stats.webp 559w\" alt=\"\" src=\"/images/tr/RnD-Stats.webp\" loading=\"lazy\" class=\"stat-graph\"> <p class=\"description\">2006-2021 döneminde Türkiye'deki toplam özel sektör Ar-Ge harcamalarının %30,3'ü uluslararası sermayeli şirketlerce yapılmıştır.</p> </div> <div class=\"stats-grid grid\"> <div> <h5 class=\"h6-heading turqoise right-aligned\"><span class=\"stat-heading\">730</span> TOPLAM PATENT<br>BAŞVURUSU</h5> </div> <p class=\"description\">Uluslararası sermayeli şirketler yıllık ortalama 730 patent başvurusu yapmıştır.</p> </div> <div class=\"stats-grid grid\"> <div> <h5 class=\"h6-heading turqoise right-aligned\"><span class=\"stat-heading\">6</span> KAT<br>ARTIŞ</h5> </div> <p class=\"description\">2006-2021 döneminde Ar-Ge yapan uluslararası sermayeli şirket sayısı 6 katına çıkmıştır.</p> </div> </div> </div>"
            },
            {
                "id": "local-sourcing",
                "iconClass": "turqoise",
                "icon": "",
                "heading": "Yerelden Tedarik",
                "content": "<div id=\"w-node-_0a09421c-a7b6-5fd2-8a2c-c560abd8b29a-bda32aac\" class=\"tab-bento-card\"> <div class=\"bento-card-header gap0\"> <div class=\"stats-grid grid no-border\"> <div id=\"w-node-_0a09421c-a7b6-5fd2-8a2c-c560abd8b29d-bda32aac\" class=\"h6-heading yellow\"><strong>Yerelden Tedarik</strong></div> <img sizes=\"100vw\" srcset=\"/images/tr/Local-Content-Ratio.webp 500w, /images/tr/Local-Content-Ratio.webp 793w\" alt=\"\" src=\"/images/tr/Local-Content-Ratio.webp\" loading=\"lazy\" class=\"stat-graph\"> <p class=\"description\">2006-2021 döneminde, uluslararası sermayeli şirketler toplam tedariklerinin %71,8'ini yerelden gerçekleştirmiştir.</p> </div> </div> </div>"
            }
        ]
    },
    "keyFindingsSection": {
        "sectionId": "key-findings",
        "tagline": "UDY STRATEJİSİ",
        "heading": "Stratejiye Yön Veren 10 Temel Bulgu",
        "description": "Uluslararası doğrudan yatırımların küresel ve bölgesel görünümü ile bu görünümü şekillendiren trendlere yönelik detaylı analizler neticesinde, stratejiye yön veren 10 temel bulgu tespit edilmiştir. Söz konusu bulgular, Türkiye için nitelikli UDY profillerinin belirlenmesine ve strateji kapsamında ortaya konan politika alanlarının tasarlanmasına önemli katkılar sağlamıştır.",
        "slides": [
            {
                "id": "slide1",
                "number": "01",
                "heading": "Küresel UDY akımlarında yaşanan durgunluğa rağmen Türkiye’nin bulunduğu bölgeye yönelen yatırımlar büyük oranda artmıştır.",
                "description": "Türkiye, bu süreçte bölgesinin en fazla yatırım çeken ülkelerinden biri olmuştur. Önümüzdeki süreçte bu avantajlı konumunu koruyarak daha da güçlendirme potansiyeline sahiptir.",
                "image": "/images/0-new-rising-trend.avif"
            },
            {
                "id": "slide2",
                "number": "02",
                "heading": "Bölgeye yönelen katma değeri yüksek hizmet sektörü yatırımları, son yıllarda artış trendindedir.",
                "description": "Orta – yüksek teknolojili imalat yatırımlarında bölgesinde lider konumda olan Türkiye, katma değeri yüksek hizmet sektörü yatırımlarındaki payını artırarak bu alanda ortaya çıkan fırsatlardan daha fazla faydalanabilir.",
                "image": "/images/city-service-network_1.avif"
            },
            {
                "id": "slide3",
                "number": "03",
                "heading": "Sürdürülebilir kalkınma ve iklim değişikliği son yıllarda küresel UDY akımlarını etkileyen en önemli kavramdan biri haline gelmiştir.",
                "description": "Özellikle yeşil enerjiye erişim, yeşil işgücü, kurumsal sürdürülebilirlik ve ESG (çevresel, sosyal ve yönetişim) raporlaması, uluslararası standartlara uyum vb. hususların yatırımcı karar kriterlerindeki ağırlığı artmaktadır. Türkiye, yeşil dönüşüm sürecinde ortaya koyduğu performansı artırarak iklim dostu yatırımlardan daha fazla pay alabilir. İklim dostu yatırımlarda yakalanacak artış imalat sanayiindeki ve dijital sektörlerdeki yatırımları artırma potansiyeline sahiptir.",
                "image": "/images/GlobalFDI-Trend-05_1.webp"
            },
            {
                "id": "slide4",
                "number": "04",
                "heading": "Küresel değer zincirlerinde yaşanan dönüşüm sürecinde yakından tedarik (nearshoring) ve dost ülkelerden tedarik (friend-shoring) eğilimleri önem kazanmakta ve UDY akımlarını etkilemektedir.",
                "description": "Türkiye sahip olduğu üretim kabiliyetleri, nitelikli insan kaynağı, gelişmiş pazarlara yakın konumu ve küresel entegrasyonu ile bu dönüşüm sürecinden kazançlı çıkabilecek ülkelerden biridir. Türkiye, uluslararası uygulamalarla uyumunu arttırarak ve yatırım ortamında gerekli iyileştirmeleri sağlayarak imalat sanayiindeki lider konumunu Ar-Ge ve tasarım gibi nitelikli alanlara da taşıyabilir. Bu sayede, küresel değer zincirlerindeki konumunu daha da güçlendirebilir.",
                "image": "/images/GlobalFDI-Trend-01.webp"
            },
            {
                "id": "slide5",
                "number": "05",
                "heading": "Dijital sektörlerde yaşanan hızlı büyüme ve geleneksel sektörlerde yaşanan dijitalleşme eğilimleri, küresel UDY akımlarını etkileyen önemli bir olgu olarak karşımıza çıkmaktadır.",
                "description": "Türkiye bu süreçte, STEM (fen, teknoloji, mühendislik ve matematik) alanlarındaki eğitim kalitesini, mevcut insan kaynağının dijital becerilerini, veri politikalarındaki uluslararası uyumunu ve dijital altyapısını daha da güçlendirerek büyüyen bu pazardaki payını arttırabilir.",
                "image": "/images/GlobalFDI-Trend-06_1.webp"
            },
            {
                "id": "slide6",
                "number": "06",
                "heading": "Son yıllarda ticaret ve teknoloji savaşları üzerinden kendini gösteren korumacı politikalar pandeminin de etkisiyle uluslararası doğrudan yatırımları daha fazla etkilemeye başlamıştır.",
                "description": "Ülkeye gelen ve ülkeden çıkan yatırımlara yönelik uygulanan kısıtlayıcı politikalar, bilhassa yüksek teknolojili sektörlerdeki yatırımcılara bazı engeller çıkarabilmektedir. Türkiye, sunduğu yatırımcı dostu ortam sayesinde bu durumu fırsata çevirebilir.",
                "image": "/images/GlobalFDI-Trend-02_1.webp"
            },
            {
                "id": "slide7",
                "number": "07",
                "heading": "Dünya genelinde UDY projeleri içerisinde mega projelerin payı hızla artmaktadır. Türkiye’nin içerisinde yer aldığı geniş bölge de bu tür yatırımların yöneldiği en önemli destinasyonlardan biridir.",
                "description": "Türkiye, yatırımcılara sunduğu özel teşvik mekanizmalarını bu süreçte daha etkin kullanarak bu büyüyen pastadan daha fazla pay alabilir. Bunun yanı sıra, yatırıma hazır büyük ölçekli sanayi alanlarının geliştirilmesi ve bürokratik süreçlerin hızlandırılması mega projelerin ülkeye çekilmesinde avantaj sağlayacaktır.",
                "image": "/images/new-construction.avif"
            },
            {
                "id": "slide8",
                "number": "08",
                "heading": "Türkiye, bölgesinin en fazla genişleme türü yatırım çeken ülkesidir.",
                "description": "Bu durum, Türkiye’deki mevcut yatırımcıların ülkenin sunduğu fırsatları değerlendirerek yatırımlarını muhafaza ettiğine ve genişletme eğiliminde olduğuna işaret etmektedir. Söz konusu olumlu algının Türkiye’ye yatırım yapmamış yeni yatırımcılar nezdinde de etkin tanıtımının yapılması ülkemize yönelecek olan sıfırdan yatırımları daha da artırabilecektir. Öte yandan, Türkiye’deki uluslararası şirketlerin mevcut yatırımlarını muhafaza etmelerinin teşvik edilmesi bu performansın sürdürülmesini sağlayacaktır.",
                "image": "/images/GlobalFDI-Trend-07_1.webp"
            },
            {
                "id": "slide9",
                "number": "09",
                "heading": "Türkiye’nin önemli bir üretim ve ihracat üssü olmasında uluslararası yatırımcıların önemli bir rolü bulunmaktadır.",
                "description": "Türkiye’nin toplam ihracatında uluslararası şirketlerin payı ortalama %31 seviyesindedir. Ülkemizde üretim yapan uluslararası şirketler orta-yüksek teknolojili ürün ihracatında Türkiye ortalamasının üzerindedir. Buna mukabil, yüksek teknolojili ürün ihracatında ise Türkiye ortalamasının bir miktar altında kaldığı gözlemlenmektedir. Türkiye’nin yüksek teknolojili sektörlerde ihracat odaklı üretim yatırımlarını artırması, ihracatın genel teknoloji düzeyini de yükseltecektir.",
                "image": "/images/1-shipment_reduced_1.webp"
            },
            {
                "id": "slide10",
                "number": "10",
                "heading": "Teknoloji girişimlerine yapılan yatırımlar son dönemde uluslararası doğrudan yatırımların önemli bir bileşeni olmaya başlamıştır.",
                "description": "Dünyadaki trendlere paralel olarak Türkiye’deki teknoloji girişimi yatırımları da önemli bir ilerleme kaydetmiştir. Bu performansı ile Türkiye, bölgesinde en fazla yatırım alan ülkelerden biri olmuştur. Teknoloji girişimciliği ekosisteminin güçlendirilmesi, Türkiye’nin daha fazla nitelikli finansal UDY çekmesini mümkün kılacaktır.",
                "image": "/images/GlobalFDI-Trend-08_1.webp"
            }
        ]
    },
    "insightHeroSection": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Türkiye UDY Stratejisinin Temel Hedefi ve Politika Alanları",
        "description": ""
    },
    "actionPlanHero": {
        "tagline": "UDY STRATEJİSİ",
        "heading": "Eylem Planı – 2026",
        "className": "cover-image action-plans",
        "id": "w-node-_8ef79bb6-13fa-f9cf-d760-5293f3e0cc60-e090c599",
        "paragraph": "Eylemler; nitelikli UDY profillerinde yatırım çekme performansının artırılmasını ve her profil için özel hedeflerin belirlenmesini içermektedir.",
        "downloadButton": {
            "text": "Eylem Planını İndir",
            "link": "https://www.invest.gov.tr/en/Documents/turkiye-udy-stratejisi-2026-yili-eylem-plani.pdf"
        },
        "archiveButton": {
            "text": "Geçmiş Eylem Planları",
            "tableHeaders": {
                "year": "Yıl",
                "title": "Başlık",
                "download": "İndir"
            }
        },
        "archivePlans": [
            {
                "year": "2024",
                "title": "UDY Strateji Eylem Planı 2024",
                "link": "https://www.invest.gov.tr/en/Documents/archive/turkiye-udy-stratejisi-eylem-planlari-2024.pdf?download"
            }
        ],
        "image": {
            "src": "/images/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover.webp",
            "alt": "cover-visual",
            "srcset": "/images/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover-p-500.webp 500w, /images/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover-p-800.webp 800w, /images/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover.webp 1600w"
        }
    },
    "actionPlanData": {
        "actions": [
            {
                "action_no": "1.1.1",
                "action": "Uluslararası firmaların Ortak Hizmet Merkezlerini (OHM) ülkemize kazandırmak üzere kolaylaştırıcı ve teşvik edici uygulamalar hayata geçirilecektir.",
                "description": "Çok uluslu şirketlerin OHM yatırımlarının ülkemize çekilmesi konusunda mevcut teşvik mekanizmaları haricinde uygulamalar geliştirilecektir.",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı,Ticaret Bakanlığı,YOİKK kapsamındaki STK’lar"
            },
            {
                "action_no": "1.1.2",
                "action": "Uzun vadeli yatırım kredileriyle ilgili stratejik önceliklendirme çalışması yapılacaktır.",
                "description": "Finansman imkânlarına erişimin artırılması kapsamında TCMB Yatırım Taahhütlü Avans Kredisi (YTAK) programında stratejik önceliklendirme yapılacaktır.",
                "responsible_institution": "Türkiye Cumhuriyet Merkez Bankası",
                "related_institutions": "Hazine ve Maliye Bakanlığı,Sanayi ve Teknoloji Bakanlığı,Ticaret Bakanlığı,Strateji ve Bütçe Başkanlığı,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "1.1.3",
                "action": "Sanayinin yeşil ve dijital dönüşümünü hızlandıracak teşvik mekanizmalarının hayata geçirilecektir.",
                "description": "Ulusal teşvik mekanizmalarının İkiz Dönüşüm eksenli olarak yeniden planlanacaktır.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "Hazine ve Maliye Bakanlığı,Ticaret Bakanlığı,Strateji ve Bütçe Başkanlığı,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "1.2.1",
                "action": "Yatırımcıların faydalanması için uygun yatırım yerlerini içeren yatırım yeri envanteri oluşturulacaktır.",
                "description": "Belirlenecek pilot illerde nitelikli yatırımlara uygun araziler tespit edilecektir.",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı,Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "1.2.2",
                "action": "Yatırım yeri tahsis süreçlerinde etkin bir koordinasyon mekanizması kurulacak ve özellikle stratejik ve büyük ölçekli yatırımlarda süreçlerin daha hızlı işlemesini sağlayacak yeni tahsis modelleri geliştirilecektir.",
                "description": "Yatırım yeri tahsis mekanizmaları ile ilgili bürokrasinin azaltılması ve mevzuat güncellemeleri hakkında tespit ve öneri raporu hazırlanacaktır.",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı,Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "1.3.1",
                "action": "Teknoloji start-up şirketleri için hisse bazlı uzun vadeli primlerin yaygınlaştırılması amacıyla düzenleme yapılacaktır.",
                "description": "Özellikle teknoloji alanındaki start-up çalışanlarının teşviki amacıyla uzun vadeli prim sistemleri oluşturulacaktır.",
                "responsible_institution": "Hazine ve Maliye Bakanlığı",
                "related_institutions": "Gelir İdaresi Başkanlığı,Sanayi ve Teknoloji Bakanlığı,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "1.3.2",
                "action": "Girişim Sermayesi Yatırım Fonlarına (GSYF) ilişkin yurt dışı yatırım limiti artırılacaktır.",
                "description": "Girişim Sermayesi Yatırım Fonlarına İlişkin Esaslar Tebliğinin 23’üncü maddesinde yer alan azami %10 oranının değiştirilmesine yönelik düzenleme yapılacaktır.",
                "responsible_institution": "Hazine ve Maliye Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "1.4.1",
                "action": "Yatırım Süreçleri Kılavuzunda belirlenen ve zaman kaybına sebep olan prosedürlerin uygulayıcı kurumlarca en aza indirilmesi sağlanacaktır.",
                "description": "1. Yatırım Süreçleri Kılavuzunda yer alan prosedürlerde sadeleştirilebilecek hususlar özel sektör çatı kuruluşlarıyla işbirliği içinde belirlenecektir.\n2. Dünya Bankası tarafından 180 ülkenin iş ve yatırım ortamını analiz etmek üzere geliştirilen Business Ready Projesi kapsamında yer alacak konulara yönelik olarak reform alanları tespit edilecek ve yıllık eylem planı hazırlanacaktır.",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "İlgili Kurum ve Kuruluşlar"
            },
            {
                "action_no": "1.5.1",
                "action": "Yatırımcı ile kamu kurumları arasında çıkan yatırım uyuşmazlıklarının tarafların uzlaşması yoluyla en hızlı ve en az maliyetle sonuçlandırılmasını sağlamak üzere alternatif çözüm usulleri geliştirilecektir.",
                "description": "1. Geniş katılımlı bir komisyon kurularak ihtiyaç analizi ve gerekli çalışmalar yapılacaktır.\n2. İdari sulh usulünün etkinleştirilmesine yönelik mevzuat hazırlık çalışmaları tamamlanacaktır.",
                "responsible_institution": "Adalet Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı,Cumhurbaşkanlığı Yatırım Ofisi,Strateji ve Bütçe"
            },
            {
                "action_no": "1.5.2",
                "action": "İtiraz, istinaf ve temyiz kanun yollarına başvuru sürelerinin yeknesak hale getirilmesi ve bu sürelerin tebliğden itibaren başlamasına ilişkin düzenleme çalışması yapılacaktır.",
                "description": "Adalet Bakanlığınca yürütülen ilgili mevzuat değişiklikleri çalışması ilgili kurum ve kuruluşların katkısı alınarak tamamlanacaktır.",
                "responsible_institution": "Adalet Bakanlığı",
                "related_institutions": "İçişleri Bakanlığı,Hazine ve Maliye Bakanlığı,Aile ve Sosyal Hizmetler Bakanlığı,Çevre,Şehircilik ve İklim Değişikliği Bakanlığı,Strateji ve Bütçe Başkanlığı,Personel Prensipler Başkanlığı"
            },
            {
                "action_no": "1.6.1",
                "action": "Alanında öncül bilimsel ve teknolojik bilgi üreten ulusal veya uluslararası firmaların Türkiye’de kuracağı Ar-Ge laboratuvarları desteklenecektir.",
                "description": "Öncül Ar-Ge Laboratuvarları Destekleme Programı çerçevesinde THS 1-4 aralığındaki Ar-Ge faaliyetleri desteklenecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "TÜBİTAK"
            },
            {
                "action_no": "2.1.1",
                "action": "Hidrojen yakıt hücresi ve bileşenleri ile hidrojen temelli motorlara yönelik yatırım ve teknolojilerin geliştirilmesi çalışmaları yürütülecektir.",
                "description": "1. Yakıt pili modülü (100 kW) üretilecek, farklı uygulama alanları için farklı kapasitelerde modül\/sistem geliştirme çalışmaları yürütülecektir.\n2. Tip Onay Mevzuatı Kapsamında gerekli çalışmalar yürütülecektir.\n3. Yük taşıma araçları için hidrojen depolama, dolum ve yakıt pili sistemlerinin geliştirilmesi çalışmaları yürütülecektir.\n4. Hidrojen Temelli Karbon-Nötr İçten Yanmalı Motor Geliştirilmesi Projesi kapsamında çalışmalar yürütülecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "Enerji ve Tabi Kaynaklar Bakanlığı,TÜBİTAK,İlgili Özel Sektör Kuruluşları"
            },
            {
                "action_no": "2.1.2",
                "action": "Yenilenebilir enerji kaynaklarına dayalı ek kapasitelerin kurulabilmesine imkân sağlayacak kanuni değişiklik ihtiyacı TBMM’ye sunulacaktır.",
                "description": "Doğal ve yapay göller üzerine Güneş Enerjisine Dayalı Elektrik Üretim Tesisi (GES) kurulumuna imkân sağlanması amacıyla 3621 sayılı Kıyı Kanununa ilişkin düzenleme ihtiyacı TBMM’ye sunulacaktır.",
                "responsible_institution": "Enerji ve Tabii Kaynaklar Bakanlığı",
                "related_institutions": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı,Tarım ve Orman Bakanlığı,Strateji ve Bütçe Başkanlığı,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "2.1.3",
                "action": "Yerli aksam yükümlülüğü olan yeni Yenilenebilir Enerji Kaynak Alanları (YEKA) ihaleleri yapılacak, deniz üstü YEKA projeleri geliştirilmesine yönelik çalışmalar yürütülecektir.",
                "description": "1. En az bir adet YEKA yarışması yapılacaktır.\n2. En az bir adet deniz üstü rüzgâr santrali alanı belirlenecektir.",
                "responsible_institution": "Enerji ve Tabii Kaynaklar Bakanlığı",
                "related_institutions": null
            },
            {
                "action_no": "2.1.4",
                "action": "Yatırımlar (Yenilenebilir Enerji)  için ayrılabilecek Hazine arazileri ülkemizin uzun dönemli yatırım ihtiyaçları çerçevesinde çevresel ve sosyal etkiler ile lojistik gereksinimler dikkate alınarak bölgesel ve sektörel bazda belirlenecektir.",
                "description": "Lisanssız Rüzgar Enerjisi Santrali (RES) ve Güneş Enerjisi Santrali (GES) kurulmak üzere Hazine arazileri ilana çıkarılacaktır.",
                "responsible_institution": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı",
                "related_institutions": "\"Enerji ve Tabii Kaynaklar\nBakanlığı\",Kültür ve Turizm Bakanlığı,Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "2.2.1",
                "action": "Tüm atıkların insan sağlığına ve çevreye olan zararlı etkilerinin en aza indirilebilmesi için havaya, suya ve toprağa salımına ilişkin gerekli tedbirler alınacaktır.",
                "description": "En iyi tekniklerle endüstriyel emisyonların yönetimi ikincil mevzuat hazırlanacaktır.",
                "responsible_institution": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji"
            },
            {
                "action_no": "2.2.2",
                "action": "Ulusal Döngüsel Ekonomi Eylem Planı hazırlanacaktır.",
                "description": "Ulusal ölçekte döngüsel ekonomi ilkelerinin etkin şekilde uygulanabilmesini teminen eylem planı hazırlanacaktır.",
                "responsible_institution": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı,İlgili Kamu Kurum ve Kuruluşları,Yerel Yönetimler"
            },
            {
                "action_no": "2.3.1",
                "action": "Sürdürülebilirlik ve emisyon verilerinin sunumunda standardizasyon sağlanacak, bu veriler paylaşıma açılacaktır.",
                "description": "1. Uluslararası standartlarla uyumlu olacak şekilde Türkiye Sürdürülebilirlik Raporlama Standartları hazırlanacak ve iki sürdürülebilirlik raporlama standardı ile ekli 68 sektöre dayalı sürdürülebilirlik raporlama standardı yayımlanacaktır.\n2. Yatırımcıların ve şirketlerin sürdürülebilirlik risk ve fırsatlarını takip edebilmeleri için Kurumsal Yönetim Tebliğinin ekinde yer alan Sürdürülebilirlik İlkeleri Uyum Çerçevesi uluslararası  standartlarla uyumlu olarak güncellenecektir.",
                "responsible_institution": "Hazine ve Maliye Bakanlığı",
                "related_institutions": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı"
            },
            {
                "action_no": "2.3.2",
                "action": "Sürdürülebilir ekonomik faaliyetlerin tanımlanmasına ilişkin ulusal taksonomi ve ilgili mevzuat hazırlanacaktır.",
                "description": "1. AB taksonomisi başta olmak üzere, uluslararası taksonomi örnekleriyle uyumlu ve Türkiye’nin ihtiyaçlarını gözeten Ulusal Yeşil Taksonominin oluşturulmasına yönelik mevzuat çalışmaları yapılacaktır.",
                "responsible_institution": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı",
                "related_institutions": "Hazine ve Maliye Bakanlığı"
            },
            {
                "action_no": "2.3.3",
                "action": "İklim değişikliğiyle ilgili uygulamaların bütüncül bir biçimde ele alındığı temel mevzuat hazırlığı tamamlanacaktır.",
                "description": "İklim mevzuatı hazırlıkları tamamlanacaktır.",
                "responsible_institution": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı",
                "related_institutions": "İklim Değişikliği Başkanlığı,İlgili Kamu Kurum ve Kuruluşları"
            },
            {
                "action_no": "2.4.1",
                "action": "Sürdürülebilir üretim ve yeşil dönüşüm teknolojilerinin benimsenmesi, geliştirilmesi ve yaygınlaştırılması için Ar-Ge faaliyetleri ve teknoloji transferi desteklenecektir.",
                "description": "Gerçekleştirilecek Türkiye Yeşil Sanayi Projesi kapsamında açılacak Sanayide Yeşil Dönüşüm Çağrısı ve SAYEM Yeşil Dönüşüm Çağrısı ile bu alandaki faaliyetler desteklenecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı,Enerji ve Tabii Kaynaklar Bakanlığı"
            },
            {
                "action_no": "2.4.2",
                "action": "Yeşil ve dijital dönüşüm için sektörel ihtiyaçlar belirlenerek gerekli yatırımlar teşvik edilecektir.",
                "description": "1. Dijital Dönüşüm Destek Programı kapsamında desteklenecek ürün listesi hazırlanacaktır.\n2. Yeşil ve dijital dönüşüme yönelik yatırımlar öncelikli yatırım konuları arasına alınmış olup başta sektörel ihtiyaçların belirlenmesi olmak üzere gerekli mevzuat çalışmalarının tamamlanması ile yeşil ve dijital dönüşüm yatırımları teşvik edilecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "İlgili Kurum ve Kuruluşlar"
            },
            {
                "action_no": "2.5.1",
                "action": "Enerji yoğun sektörler öncelikli olmak üzere rekabetçilik ve yerli üretim dikkate alınarak enerji verimliliği yatırımları desteklenecektir.",
                "description": "1. Enerji verimliliği destek miktarlarının artırılmasına yönelik mevzuat düzenlemesi yapılacaktır.\n2. Verilecek desteklerle enerji verimliliği ve tasarruf potansiyeli yüksek teknolojik yatırımların önceliklendirilmesine yönelik mevzuat düzenlemesi yapılacaktır.",
                "responsible_institution": "Enerji ve Tabii Kaynaklar Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "2.5.2",
                "action": "Sıfır kirlilik hedefine yönelik emisyonlarını azaltarak enerji ve kaynak verimli üretim yaptığını raporlayan tesislerin temiz üretim yaptıklarını gösterecek şekilde sertifikalandırılmaları sağlanacaktır.",
                "description": "2010\/75\/AB Endüstriyel Emisyonlar Direktifinin uyumlaştırılması çalışmaları kapsamında AB Entegre Kirlilik Önleme ve Kontrol (EKÖK) Belgesi ile eş nitelikte olacak Sanayide Yeşil Dönüşüm Belgesi sisteminin kurulacaktır.",
                "responsible_institution": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı",
                "related_institutions": "Enerji ve Tabii Kaynaklar Bakanlığı,Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "2.6.1",
                "action": "Dış ticarette rekabetçiliğin korunarak daha ileriye taşınması için ulusal karbon fiyatlandırma mekanizmaları oluşturulacak, öncelikli olarak AB ile uyumlu bir Emisyon Ticaret Sistemi (ETS) uygulamaya konulacaktır.",
                "description": "1. Ulusal karbon fiyatlandırma mekanizması oluşturulacaktır. \n2. AB ile uyumlu bir Emisyon Ticaret Sistemi (ETS) uygulamaya konulacaktır.",
                "responsible_institution": "Çevre,Şehircilik ve İklim Değişikliği Bakanlığı",
                "related_institutions": "Ticaret Bakanlığı"
            },
            {
                "action_no": "2.6.2",
                "action": "Ekonomik faydanın yanı sıra sosyal ve çevresel fayda oluşturulmasına yönelik sosyal etki tahvilleri ve mavi bonolar gibi “etki yatırımı” araçları geliştirilecek ve kullanımı yaygınlaştırılacaktır.",
                "description": "1. Türkiye Kalkınma Fonu nezdinde Etki Fonu kurulacak ve bu kapsamda toplumsal sorun alanlarına sürdürülebilir şekilde fayda temin eden şirketlerin (deprem bölgesindeki firmalar dâhil) desteklenmesi sağlanacaktır.\n2. Sürdürülebilir finansal araçlara yatırım yapan yatırım fonlarına sağlanabilecek vergisel teşvikler konusunda çalışmalar yapılacaktır.",
                "responsible_institution": "Hazine ve Maliye Bakanlığı",
                "related_institutions": null
            },
            {
                "action_no": "3.1.1",
                "action": "Kişisel Verilerin Korunması Kanununun Avrupa Birliği Genel Veri Koruma Tüzüğü (GDPR) başta olmak üzere AB müktesebatına uyum sürecine yönelik çalışmalar tamamlanacaktır.",
                "description": "6698 sayılı Kişisel Verilerin Korunması Kanununun Avrupa Birliği Veri Koruma Tüzüğü (GDPR) ile Uyumlaştırılmasına yönelik çalışmalar tamamlanacaktır.",
                "responsible_institution": "Adalet Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı,Ticaret Bakanlığı"
            },
            {
                "action_no": "3.1.2",
                "action": "AB’nin Şebeke ve Bilgi Güvenliği Direktifi (NIS2) ile siber güvenlik alanındaki yeni çalışmaları ve uluslararası alanda en iyi uygulamalar dikkate alınarak ulusal siber güvenliğin sağlanmasına yönelik düzenlemeler yapılacaktır.",
                "description": "1. Ulusal siber güvenliğin sağlanmasına ve siber caydırıcılığın artırılmasına yönelik yönetmelik\nyayımlanacaktır.\n2. Nesnelerin interneti güvenliğine yönelik düzenleme çalışması yapılacaktır.\n3. Nesnelerin interneti cihazlarına yönelik siber güvenlik taramaları gerçekleştirilecektir. \n4. Hazırlık çalışmaları devam eden Ulusal siber güvenlik çatı mevzuatı ile ilişkili olarak ihtiyaç duyulan ikincil düzenlemeler belirlenecektir.\n5. Uzaktan imza hizmetine yasal altyapı teşkil etmek üzere 5070 sayılı Elektronik İmza Kanunu ve ilgili diğer mevzuata dönük çalışmalar yürütülecektir.\n6. Uzaktan imza hizmetinin kamu kurumlarında ve özel sektörde kullanımının yaygınlaştırılması için farkındalık çalışmaları yapılacaktır.",
                "responsible_institution": "\"Ulaştırma ve Altyapı Bakanlığı \nCumhurbaşkanlığı Dijital Dönüşüm Ofisi\"",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı,BTK,Kişisel Verileri Koruma Kurumu,İlgili Tüm Kamu Kurum ve Kuruluşları"
            },
            {
                "action_no": "3.1.3",
                "action": "6698 sayılı Kişisel Verilerin Korunması Kanununa ilişkin değişiklik ihtiyacı TBMM’ye sunulacaktır.",
                "description": "6698 sayılı Kişisel Verilerin Korunması Kanununun AB Genel Veri Koruma Tüzüğü (GDPR) ile uyumlaştırılmasına yönelik kanuni değişiklik ihtiyacı (Madde 6: Özel nitelikli kişisel verilerin işlenme şartları ve Madde 9: Kişisel verilerin yurt dışına aktarılması) TBMM’ye sunulacaktır.",
                "responsible_institution": "Adalet Bakanlığı",
                "related_institutions": "Dışişleri Bakanlığı,Sanayi ve Teknoloji Bakanlığı,Ticaret Bakanlığı,Strateji ve Bütçe Başkanlığı,Yatırım Ofisi,Dijital Dönüşüm Ofisi,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "3.2.1",
                "action": "Veri merkezi hizmeti sunan yerli firmaların gelişimini teşvik edecek ve rekabeti etkinleştirecek mekanizmalar oluşturulacaktır.",
                "description": "1. Veri merkezi sektörünün gelişmesine imkân veren düzenleyici çerçeve çalışması yürütülecektir. \n2. Veri merkezi, bulut bilişim ve platform hizmet sektörlerinin geliştirilmesine yönelik mevzuat yürürlüğe konulacaktır.",
                "responsible_institution": "\"Ulaştırma ve Altyapı Bakanlığı \nCumhurbaşkanlığı Dijital Dönüşüm Ofisi\"",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı,BTK,Kişisel Verileri Koruma Kurumu,TÜBİTAK,Adalet Bakanlığı,Hazine ve Maliye Bakanlığı,Strateji ve Bütçe Başkanlığı"
            },
            {
                "action_no": "3.2.2",
                "action": "5G baz istasyonlarının yerli üretimi desteklenecek, kurulumu yaygınlaştırılarak altyapı yetersizlikleri giderilecektir.",
                "description": "5G'ye yönelik verilen\/verilecek Ar-Ge destekleri belirlenecek ve geliştirilen ürünlerin ticari ve evrensel şebekelerde kullanılacaktır.",
                "responsible_institution": "Ulaştırma ve Altyapı Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "3.2.3",
                "action": "Bölgesel farklılıklar dikkate alınarak altyapıların geliştirilemediği bölgelerde genişbant altyapı kurulumu teşvik edilecektir.",
                "description": "Fiber altyapı açısından  desteklenmesi öngörülen yerlerin belirlenmesi, ilgili etki analizi çalışmalarının yapılması, destek ve teşvik yöntemleriyle ilgili alternatiflerin ortaya konulması ve maliyetin tespit edilmesine ilişkin bir rapor hazırlanacaktır.",
                "responsible_institution": "Ulaştırma ve Altyapı Bakanlığı",
                "related_institutions": "BTK"
            },
            {
                "action_no": "3.3.1",
                "action": "5G ve ötesi teknolojilerde sanayi, tarım, ulaşım, enerji gibi dikey sektörlerin gereksinimlerinin uçtan uca karşılanmasına yönelik çalışmalar yapılarak cihaz ve uygulamalar geliştirilecektir.",
                "description": "5G, 6G ve ötesi haberleşme teknolojileri kapsamında BEYOND5 RFSOI Tabanlı Avrupa Tedarik Zincirinin Oluşturulması ve 5G-Mobix projeleri kapsamında planlanan faaliyetler yürütülecektir.",
                "responsible_institution": "Ulaştırma ve Altyapı Bakanlığı",
                "related_institutions": null
            },
            {
                "action_no": "3.3.2",
                "action": "Açık Kaynak Kodlu Yazılım Kümelenmesi kurulacaktır.",
                "description": "1. Açık kaynak kodlu yazılım alanında faaliyet gösteren firma, STK ve üniversite envanteri çıkarılacaktır.\n2. Açık kaynak kodlu yazılım alanında faaliyet gösteren firmalar arasında yatay işbirliğini tesis eden ve rekabet öncesi işbirliği faaliyetlerinin belirleneceği çalıştaylar düzenlenecektir.\n3. Açık kaynak kodlu yazılım kullanımını yaygınlaştırmak üzere eğitim ve farkındalık programları düzenlenecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "Cumhurbaşkanlığı Dijital Dönüşüm Ofisi,TÜBİTAK"
            },
            {
                "action_no": "3.3.3",
                "action": "5G ve ötesi yeni nesil iletişim teknolojilerinde yazılım, donanım ve altyapı alanlarında, nesnelerin interneti, yapay zekâ, büyük veri, kuantum, siber güvenlik, akıllı ulaşım, artırılmış gerçeklik gibi gelişen teknoloji alanlarında nitelikli insan gücü yetiştirilmesi çalışmalarına ağırlık verilecektir.",
                "description": "Yapay zekâ, büyük veri ve siber güvenlik alanlarında yükseköğretim programları açılacaktır.",
                "responsible_institution": "YÖK",
                "related_institutions": "Üniversiteler"
            },
            {
                "action_no": "4.1.1",
                "action": "Dijital pazarlarda rekabet ortamının iyileştirilmesine yönelik mevzuat çalışması yapılacaktır.",
                "description": "Dijital pazarlarla ilgili olarak 4054 sayılı Rekabetin Korunması Hakkında Kanuna ilişkin değişiklik ihtiyacı TBMM’ye sunulacaktır.",
                "responsible_institution": "Ticaret Bakanlığı",
                "related_institutions": "Rekabet Kurumu,Dijital Dönüşüm Ofisi,Bilgi Teknolojileri ve İletişim Kurumu,Kişisel Verileri Koruma Kurumu,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "4.1.2",
                "action": "AB dijital ekonomi düzenlemelerinin ülkemiz ticaretini etkileyen boyutları ve atılması gereken adımlar tespit edilecektir.",
                "description": "AB tarafından son dönemde dijital ekonomiyi ilgilendiren alanlarda oluşturulan mevzuatın ülkemiz açısından ticaret engeli oluşturma riskine karşı önlem alınması amacıyla rapor ve yol haritası oluşturulacaktır.",
                "responsible_institution": "\"Ticaret Bakanlığı\nSanayi ve Teknoloji Bakanlığı\"",
                "related_institutions": "Ulaştırma ve Altyapı Bakanlığı,Dijital Dönüşüm Ofisi,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "4.2.1",
                "action": "Ülkemizin tercihli ticaret ağı güçlendirilecek, yeni serbest ticaret anlaşmaları müzakere edilecek ve yürürlükteki serbest ticaret anlaşmalarının kapsamının genişletilmesine yönelik çalışmalar yürütülecektir.",
                "description": "1. Türkiye-Japonya STA Müzakereleri sürdürülecektir.\n2. Türkiye-Tayland STA Müzakereleri sürdürülecektir.",
                "responsible_institution": "Ticaret Bakanlığı",
                "related_institutions": "Dışişleri Bakanlığı"
            },
            {
                "action_no": "4.2.2",
                "action": "Gümrük Birliği’nin güncellenmesi müzakereleri yürütülecek ve kamu, özel sektör, STK’lar ve akademisyenlerin görüşleri alınarak ulusal müzakere hazırlık çalışmaları tamamlanacaktır.",
                "description": "Müzakere pozisyonu oluşturmak üzere, kamu, özel sektör, STK’lar ve akademi temsilcilerinin katılımıyla toplantılar düzenlenecektir.",
                "responsible_institution": "Ticaret Bakanlığı",
                "related_institutions": "Dışişleri Bakanlığı,İlgli Kurum ve Kuruluşlar"
            },
            {
                "action_no": "4.3.1",
                "action": "Liman operasyonlarında enerji verimliliğinin artırılması ile çevresel etkilerin en aza indirilmesine yönelik düşük emisyonlu\/emisyon üretmeyen makine ve ekipmanların kullanımı teşvik edilerek yeşil liman uygulamalarının desteklenmesine devam edilecektir.",
                "description": "Kıyı tesislerine yeşil liman sertifikası düzenlenmesi hakkında yönetmelik uygulamaya geçirilecektir.",
                "responsible_institution": "Ulaştırma ve Altyapı Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "4.3.2",
                "action": "Tüm ulaşım modlarında, elektrikli veya diğer alternatif yakıtlı araçların kullanımı için altyapı ve teknoloji yatırımları yapılacak, yeni nesil, sürdürülebilir, bütünleşik hareketlilik hizmetleriyle ilgili uyum ve mevzuat düzenlemeleri tamamlanacaktır.",
                "description": "Limanlarda, garlarda ve karayollarında şarj istasyonu enerji altyapıları geliştirilecek, ilgili mevzuat düzenlemeleri tamamlanacaktır.",
                "responsible_institution": "Enerji ve Tabii Kaynaklar Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı,Ulaştırma ve Altyapı Bakanlığı"
            },
            {
                "action_no": "4.3.3",
                "action": "Küresel tedarik zincirinin sürdürülebilirliğinin sağlanması için ülkemizin içinde bulunduğu ulaştırma koridorlarının etkinliğini ve çeşitliliğini artırma çalışmaları devam edecektir.",
                "description": "Türk Demiryolu Sektöründe İntermodal Taşımacılık Hizmetlerinin Güçlendirilmesi Projesi tamamlanacaktır.",
                "responsible_institution": "Ulaştırma ve Altyapı Bakanlığı",
                "related_institutions": "Ticaret Bakanlığı"
            },
            {
                "action_no": "4.3.4",
                "action": "Doğu Akdeniz bölgesinde Ortadoğu ve Orta Asya ülkelerinin çıkış kapısı olacak, transit yük odaklı, bölgenin gelişmesine ve ihracatın artırılmasına katkı sağlayacak bir ana liman inşa edilecektir.",
                "description": "Ana liman inşası için yer tespiti ve fizibilite çalışmaları tamamlanacaktır.",
                "responsible_institution": "Ulaştırma ve Altyapı Bakanlığı",
                "related_institutions": "-"
            },
            {
                "action_no": "4.3.5",
                "action": "Yeni sanayi bölgeleri ve lojistik hatları afet riskleri gözetilerek oluşturulacak, mevcut demiryolu altyapısı daha etkin kullanılarak, sanayi bölgeleri ve limanlarla (RORO dâhil) bağlantıları güçlendirilecektir.",
                "description": null,
                "responsible_institution": "Ulaştırma ve Altyapı Bakanlığı",
                "related_institutions": "-"
            },
            {
                "action_no": "4.4.1",
                "action": "Yerli tedarik zincirini güçlendirecek şekilde KOBİ’lerin büyük ölçekli firmalar etrafında kümelenmeleri teşvik edilecektir.",
                "description": "Öncelikli sektörlerde yer alan büyük işletmelerle potansiyel tedarikçilerin bir araya getirilmesi amacıyla yerlileştirilmesi önceliklendirilmiş ürün listelerinin yerli tedarikçilerle üretilmesini sağlamaya yönelik eşleştirme faaliyetleri ile yerli tedarikçilerin sayısının artırılması sağlanacaktır.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "-"
            },
            {
                "action_no": "4.4.2",
                "action": "Ana sanayi üreticileri ve büyük işletmelerin tedarik zincirlerine KOBİ’lerin eklemlenebilmeleri için eşleşmeleri kolaylaştırılacak ve gerekli kalite, verim, kapasite artışları ile ürün geliştirme (Ür-Ge) faaliyetleri tedarikçi geliştirme süreçleri kapsamında desteklenecektir.",
                "description": "1. Tedarikçi Dijital Veritabanı işletmelerin yararlanması amacıyla hizmete sunulacaktır.\n2. Tedarikçi Dijital Veritabanı üzerinden yerlileştirme talep eden büyük işletmeler ile bu taleplere cevap veren KOBİ'ler bir araya getirilecektir.\n3. Tedarikçi geliştirme faaliyetleri kapsamında büyük işletme tedarikçilerinin desteklenmesi amacıyla mevcut destek programlarında ilave destek unsurları ve avantajlar sağlanacaktır.\n4. Tedarikçilerin Ar-Ge, Ür-Ge ve inovasyon faaliyetlerini desteklemek amacıyla kurum\/kuruluşlar ile işbirliği yapılacaktır.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "Hazine ve Maliye Bakanlığı,Ticaret Bakanlığı"
            },
            {
                "action_no": "4.5.1",
                "action": "Dış ticaret işlemlerinde blokzincir ve otomatik karakter tanıma (OCR) gibi yenilikçi teknolojiler kullanılarak kâğıtsız ortamda gümrük uygulamaları yaygınlaştırılacaktır.",
                "description": "1. BİLGE sisteminde blokzincir (İhracat Zinciri) kullanımına ilişkin çalışmalar yürütülecektir.\n2. İthalatta kâğıtsız gümrük uygulamalarına geçiş için gerekli teknik çalışmalar yapılacaktır.",
                "responsible_institution": "Ticaret Bakanlığı",
                "related_institutions": "-"
            },
            {
                "action_no": "4.5.2",
                "action": "İhracat işlemlerinde blokzincir teknolojisinin kullanılmasına ilişkin yürütülen çalışmaların Bilgisayarlı Gümrük Etkinlikleri (BİLGE) Sistemini de kapsayacak şekilde geliştirilmesi sağlanacaktır.",
                "description": "İhracat işlemleriyle ilgili tüm gümrük ve lojistik süreçlerinin blokzincir altyapısı kullanılarak süreçteki tüm paydaşlarca elektronik ortamda tek bir ekrandan yürütülebilmesi ve izlenebilmesine sağlayacak İhracat Zinciri Projesi hayata geçirilecektir.",
                "responsible_institution": "Ticaret Bakanlığı",
                "related_institutions": "-"
            },
            {
                "action_no": "4.6.1",
                "action": "Öncelikli sektörler başta olmak üzere firma iş ortaklıkları yüksek teknolojili Ür-Ge ve ticarileştirmesinin desteklendiği Sanayi Yenilik Ağ Mekanizması Programı yaygınlaştırılacaktır.",
                "description": "Türkiye Yeşil Sanayi Projesi kapsamında açılacak, Sanayide Yeşil Dönüşüm Çağrısı ve SAYEM Yeşil Dönüşüm Çağrısı ile bu alandaki faaliyetler desteklenecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "TÜBİTAK,Üniversiteler"
            },
            {
                "action_no": "5.1.1",
                "action": "Uzaktan ya da yerinde yurt dışına çalışmakta olan yazılımcıların yerli bilişim sektörünün katma değerini artıracak şekilde istihdam edilebilmeleri için önlemler alınacaktır.",
                "description": "Üniversitelerin ilgili bölümlerinden yeni mezun olan ve belirli bir süre aynı şirkette çalışan kişilere yönelik yeni yazılımcı teşviki uygulaması hayata geçirilecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "Hazine ve Maliye Bakanlığı Cumhurbaşkanlığı Dijital Dönüşüm Ofisi,Cumhurbaşkanlığı İnsan Kaynakları Ofisi"
            },
            {
                "action_no": "5.1.2",
                "action": "İkiz Dönüşüm kapsamında ihtiyaç duyulan mesleklerde becerilerin belirlenmesi ve belirlenen becerileri dikkate alan eğitim içerikleri\/modüllerinin geliştirilmesi, işbaşı eğitim programı ve mesleki eğitim kurslarının gerçekleştirilmesi",
                "description": "1. İkiz Dönüşüm kapsamında ihtiyaç duyulan mesleklerde becerilerin ortak çalışma yapılarak belirlenmesi\n2. İkiz Dönüşüm kapsamında ilgili mesleklerde belirlenen becerileri dikkate alan eğitim içerikleri\/modüllerinin YÖK ile koordine edilerek geliştirilmesi\n3. Geliştirilen eğitim modüllerini dikkate alarak işbaşı eğitim programı ve mesleki eğitim kurslarının TİSK ve TOBB iş birliğinde gerçekleştirilmesi\n",
                "responsible_institution": "Çalışma ve Sosyal Güvenlik Bakanlığı",
                "related_institutions": "İŞKUR"
            },
            {
                "action_no": "5.1.3",
                "action": "Ar-Ge ve Tasarım Merkezleri ile Teknoloji Geliştirme Bölgelerinde uzaktan çalışma uygulaması devam ettirilecektir.",
                "description": "Ar-Ge ve Tasarım Merkezleri ile Teknoloji Geliştirme Bölgesi çalışanlarına yönelik sağlanan uzaktan çalışma hakkının, özellikle dijital teknolojilerde çalışanlar için sürekli olarak %100 uzaktan çalışma olacak şekilde devamlılığı sağlanacaktır.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "Hazine ve Maliye Bakanlığı,Strateji ve Bütçe Başkanlığı,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "5.2.1",
                "action": "Araştırma deneyimine sahip nitelikli insan kaynağının artırılmasını teminen kamu destekli Ar-Ge projelerinde daha fazla lisans, yüksek lisans ve doktora bursiyerinin yer alması sağlanacaktır.",
                "description": "1. Doktora öğrencilerinin Ar-Ge projelerinde yer almasının teşvik edilmesi amacı ile Lisansüstü Bursları Performans Programı yılda iki kez çağrıya açılarak başvuru ve destek süreçleri yürütülecektir.\n2. Stajyer Araştırmacı Burs Programı kapsamında yılda iki defa çağrıya çıkılacak ve program kapsamında desteklenen bursiyerlerin projelerde yer alması sağlanacaktır.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "YÖK,TÜBİTAK,Üniversiteler"
            },
            {
                "action_no": "5.2.2",
                "action": "Üst seviye bilimsel ve teknolojik çalışmalar yürüten nitelikli araştırmacıların özel programlarla desteklenmesine devam edilecektir.",
                "description": "1. Uluslararası Lider\/Genç Araştırmacılar Programları çağrıya açılarak başvuru, destek ve izleme süreçleri yürütülecektir.\n2. Ulusal Lider Araştırmacılar Programı ve Ulusal Genç Liderler Programları çağrıya açılarak başvuru, destek ve izleme süreçleri yürütülecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "YÖK,TÜBİTAK,Üniversiteler"
            },
            {
                "action_no": "5.2.3",
                "action": "Sanayide ihtiyaç duyulan doktora derecesine sahip nitelikli insan kaynağının üniversite sanayi işbirliğiyle yetiştirilmesi sağlanacak ve doktoralı araştırmacı istihdamı teşvik edilecektir.",
                "description": "Sanayi Doktora Programı kapsamında doktora öğrencileri desteklenecek ve sanayide doktoralı araştırmacı istihdamı teşvik edilecektir.",
                "responsible_institution": "Sanayi ve Teknoloji Bakanlığı",
                "related_institutions": "YÖK,TÜBİTAK,Üniversiteler"
            },
            {
                "action_no": "5.2.4",
                "action": "Temel bilimlere yönelik lisansüstü burs miktarı ve faydalanan sayısı artırılacaktır.",
                "description": "Temel Bilimlerde Genç Beyinler Projesi ile devlet üniversitelerinde fizik, kimya, biyoloji ve matematik alanlarından birinde doktora eğitiminin tez aşamasında olan araştırma görevlilerine burs desteği verilerek yurt dışında araştırma yapma imkânı sağlanacaktır.",
                "responsible_institution": "YÖK",
                "related_institutions": "Üniversiteler"
            },
            {
                "action_no": "5.3.1",
                "action": "Yabancı dilde uluslararası standartlarda eğitim verilerek öğrencilerin ileri düzeyde okuma, anlama, konuşma ve yazma becerilerini edinmeleri sağlanacaktır.",
                "description": "1. Yabancı dil eğitimine yönelik politikalar güncel yaklaşımlarla uyumlu olarak ele alınarak dinleme, konuşma, okuma ve yazma alanlarındaki beceriler geliştirilecek ve öğretim programlarında kullanılan dil yeterlik çerçevesi ile ilgili hizmet içi eğitimler yapılarak öğretmenlerin bilgi ve becerileri artırılacaktır.\n2. Öğrencilerin yabancı dil becerilerinin geliştirilmesi için ortaokul beşinci sınıflarda uygulanan yabancı dil hazırlık sınıfı İngilizce ve Almanca olarak yapılandırılacak ve belirlenen okullarda 2023-2024 eğitim öğretim yılında pilot uygulama yapılacaktır.\n3. Yabancı dil eğitimine ilişkin materyaller zenginleştirilecek, dinleme, konuşma, okuma ve yazma alanlarındaki becerilerin tümünü ölçmeye yönelik sistem geliştirilecektir.",
                "responsible_institution": "Milli Eğitim Bakanlığı",
                "related_institutions": "-"
            },
            {
                "action_no": "5.4.1",
                "action": "Mesleki ve teknik öğretim kurumları ile Organize Sanayi Bölgeleri arasında iş birliği protokolleri oluşturulacaktır.",
                "description": "1. OSB’lerin kuruluş aşamasında pansiyonlu mesleki ve teknik ortaöğretim kurumu ile birlikte planlanması ve bu konunun standart hale gelmesi için çalışma yürütülecektir.\n2. Henüz bünyesinde mesleki ve teknik ortaöğretim kurumu bulunmayan OSB’lerde Millî Eğitim Bakanlığı ile iş birliği içinde pansiyonlu okul binaları yapılacak, yapılan okullar Millî Eğitim Bakanlığı ya da OSB yönetimine bağlı olarak faaliyet gösterecektir.",
                "responsible_institution": "\"Millî Eğitim Bakanlığı \nSanayi ve Teknoloji Bakanlığı\"",
                "related_institutions": "Organize Sanayi Bölgeleri Üst Kuruluşu,Sanayi ve Ticaret Odaları,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "5.4.2",
                "action": "Mesleki ve teknik öğretim kurumları ile Sanayi ve Ticaret Odaları ve Organize Sanayi Bölgeleri yönetimleri başta olmak üzere özel sektör kurumlarıyla eşleştirmeler yapılacak ve mesleki eğitim alanında sektörel kümelenmeler sağlanacaktır.",
                "description": "1. Mesleki ve teknik ortaöğretim okullar ile OSB’ler eşleştirilecek ve eşleştirilen okullar OSB’ler tarafından öğrencilerin beceri eğitimi, mezunların istihdamı ve öğretmenlerin iş başında mesleki gelişiminin sağlanması bakımından desteklenecektir.\n2. Özellikle Sanayi ve Ticaret Odalarıyla ve Organize Sanayi Bölgeleri yönetimleriyle birlikte örnek pilot uygulamalar hayata geçirilecek ve örnek uygulamalara dayalı eşleştirme modeli yaygınlaştırılacaktır.",
                "responsible_institution": "\"Millî Eğitim Bakanlığı \nSanayi ve Teknoloji Bakanlığı\"",
                "related_institutions": "Organize Sanayi Bölgeleri Üst Kuruluşu,Sanayi ve Ticaret Odaları,YOİKK kapsamındaki Kurum,Kuruluş ve STK’lar"
            },
            {
                "action_no": "5.5.1",
                "action": "İlkaşama girişimcileri için vize modelinin oluşturulması sağlanarak yurt dışındaki girişimcilerin Türkiye’ye gelmesini cazip kılacak destek ve düzenlemeler yapılacaktır.",
                "description": "İlkaşama girişimcileri için vize modeline yönelik faaliyetler sürdürülerek gerekli destek ve düzenlemeler hayata geçirilecektir.",
                "responsible_institution": "Çalışma ve Sosyal Güvenlik Bakanlığı",
                "related_institutions": "İçişleri Bakanlığı,Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "5.5.2",
                "action": "Ar-Ge veya Ür-Ge faaliyetleri yürütülmesi, yatırımın yapılması, yönetilmesi veya işletilmesiyle ilgili olarak ülkeye gelecek diğer ülke vatandaşlarına ve ailelerine ikamet ve çalışma izni verilmesinde öncelik ve kolaylık sağlanacaktır.",
                "description": "Teknolojik dönüşüm ve dijitalleşme sürecinin getirdiği uzaktan çalışma şeklinin sektörel, mesleki ve bölgesel işgücü göçü bağlamında etkilerinin analiz edilmesine yönelik araştırma çalışması yapılacaktır.",
                "responsible_institution": "Çalışma ve Sosyal Güvenlik Bakanlığı",
                "related_institutions": "İçişleri Bakanlığı,Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "5.5.3",
                "action": "Nitelikli yabancı uyruklu doktoralı araştırmacı ve akademisyenlerin istihdamını özendirici ve kolaylaştırıcı çalışmalar yürütülecektir.",
                "description": "İhtiyaç duyulan alanlarda yabancı uyruklu doktoralı uluslararası bilim insanlarının istihdamı desteklenecektir.",
                "responsible_institution": "YÖK",
                "related_institutions": "Üniversiteler"
            },
            {
                "action_no": "5.6.1",
                "action": "Mevcut işgücünün becerilerinin geliştirilmesi desteklenecek, işgücünde yer almayanların sanayinin ihtiyaç duyduğu becerilerle donatılması kamu-özel işbirliğiyle sağlanacaktır.",
                "description": "Sanayi sektöründe emek arzı ile işgücü piyasası ihtiyaçları arasında uyumu güçlendirmeye yönelik aktif işgücü piyasası programları kapsamında 40 bin kişiye yönelik mesleki eğitim kursu ve işbaşı eğitim programı düzenlenecektir.",
                "responsible_institution": "Çalışma ve Sosyal Güvenlik Bakanlığı",
                "related_institutions": "Sanayi ve Teknoloji Bakanlığı"
            },
            {
                "action_no": "5.6.2",
                "action": "Eğitimde ve istihdamda olmayan gençlerin istihdama erişimlerini desteklemeye yönelik programların etkinliği artırılacaktır.",
                "description": "İŞKUR tarafından gençlere yönelik olarak verilen hizmetleri tek bir çatı altında toplamak ve gençlerin söz konusu hizmetleri tek bir platformdan takip etmelerine imkân sağlamayı amaçlayan İŞKUR gençlik internet sitesi uygulamaya açılarak kullanımı yaygınlaştırılacaktır.",
                "responsible_institution": "Çalışma ve Sosyal Güvenlik Bakanlığı",
                "related_institutions": "İŞKUR,Milli Eğitim Bakanlığı"
            },
            {
                "action_no": "5.6.3",
                "action": "Merkezi yönetim, yerel yönetimler, özel sektör ve STK’larla işbirliğiyle kadın istihdamını artırmak üzere kaliteli, ekonomik ve erişilebilir bakım hizmetlerine ilişkin alternatif modeller geliştirilmesi ve pilot uygulamaları takiben yaygınlaştırılması sağlanacaktır.",
                "description": "Merkezi yönetim, yerel yönetimler, özel sektör ve STK’larla işbirliğiyle kadın istihdamını artırmak üzere kaliteli,  ekonomik ve erişilebilir bakım hizmetlerine ilişkin alternatif\nmodeller geliştirilmesi konusunda çalışmalar yapılacaktır.",
                "responsible_institution": "Aile ve Sosyal Hizmetler Bakanlığı",
                "related_institutions": "Çalışma ve Sosyal Güvenlik Bakanlığı,Mahalli İdareler,STK’lar,Özel Sektör Kuruluşları"
            },
            {
                "action_no": "6.1.1",
                "action": "Türkiye yatırım ortamının ulusal ve uluslararası ölçekte tanıtımı için etkinlikler düzenlenecek ve önde gelen etkinliklere katılım sağlanacaktır.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.1.2",
                "action": "Türkiye yatırım ortamının etkin bir şekilde tanıtılması için yeni bir iletişim ve tanıtım stratejisi hazırlanıp uygulanacaktır.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.1.3",
                "action": "Konvansiyonel, dijital ve sosyal mecralarda iletişim ve tanıtma faaliyetleri için özel içerikler üretilecek ve dil seçenekleri artırılacaktır.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.2.1",
                "action": "invest.gov.tr kurumsal internet sitesi, Türkiye'nin uluslararası doğrudan yatırım ortamı hakkında değer önerisini tanıtmak ve yatırımcıları fırsatlara yönlendirmek için ana platform olarak tekrar tasarlanacak ve kullanıma açılacaktır.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.2.2",
                "action": "“Invest in Türkiye” markasının yeniden konumlandırılması için kurumsal kimlik öğeleri güncellenecektir.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.3.1",
                "action": "Nitelikli UDY profilleri özelinde, öncelikli ülke ve bölgelerde sektörel tanıtım etkinlikleri düzenlenecek ve önde gelen etkinliklere katılım sağlanacaktır.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.3.2",
                "action": "Nitelikli UDY profilleri özelinde Türkçe ve ihtiyaç duyulan yabancı dillerde sektör raporları hazırlanacak ve bu raporlar her yıl güncellenecektir.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.3.3",
                "action": "Nitelikli UDY profillerinde Türkiye'deki yatırım fırsatlarının etkin tanıtımı için ana mesajlar ve özgün içerikler (message house) kurgulanacak, dinamik stratejiler geliştirilecektir.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.3.4",
                "action": "Uluslararası yatırımcılara yönelik yatırım yapılmaya hazır projelerin yer alacağı bir portföy (KÖİ, sanayi işbirliği projeleri, M&A yatırımları vb.) oluşturulacaktır.",
                "description": null,
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.4.1",
                "action": "Ülkemizin teknoloji girişimi (startup) ekosisteminin ve büyüme potansiyeli yüksek teknoloji girişimlerinin uluslararası ölçekte tanıtımı yapılacaktır.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.4.2",
                "action": "Her bir nitelikli UDY profili kapsamında 2024-28 dönemi için potansiyel yatırım alanları ve ülke\/bölge özelinde potansiyel yatırımcı şirketler tespit edilecek, bu şirketlere yönelik yatırım çekme faaliyetleri yürütülecektir.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.4.3",
                "action": "Türkiye'de faaliyet gösteren UDY firmalarının ülkemizdeki yatırımlarını daha katma değerli alanlara (ar-ge ve tasarım merkezi, bölgesel yönetim merkezi, ortak hizmet merkezi, bölgesel dağıtım merkezi vb.) genişletmesi için hedef odaklı yatırım çekme faaliyetleri yürütülecektir.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.5.1",
                "action": "Uluslararası şirketlerde görev yapan Türk yöneticiler ve yurt dışında yerleşik Türk girişimciler ile iş birliği ve istişare mekanizmaları geliştirilecek ve ülkemizin yatırım ortamının tanıtılmasında ortak faaliyetler yürütülecektir.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.5.2",
                "action": "Ülkemizde faaliyet gösteren uluslararası yatırımcıların olumlu tecrübelerini ve Türkiye’nin değer önerilerini aktaran içerikler hazırlanarak tanıtma faaliyetlerinde kullanılacaktır.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.5.3",
                "action": "Türkiye UDY Stratejisi ve nitelikli UDY profilleri yatırım ekosisteminde yer alan önemli paydaşlara (büyükelçilikler, ticaret müşavirlikleri, kalkınma ajansları ve ilgili diğer kamu kurumları vb.) tanıtılacaktır.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            },
            {
                "action_no": "6.5.4",
                "action": "Türkiye’de yerleşik iş örgütlerine, uluslararası kuruluşlara, medya kuruluşlarına ve gazetecilere yönelik iletişim ve iş birliği programları geliştirilecektir.",
                "description": "-",
                "responsible_institution": "Cumhurbaşkanlığı Yatırım Ofisi",
                "related_institutions": "-"
            }
        ],
        "policies": [
            {
                "policy_no": "1.1",
                "policy": "Türkiye ekonomisinin ikiz (yeşil ve dijital) dönüşümünü destekleyecek nitelikli UDY projelerinin çekilebilmesi için yatırımcılara sunulan teşvik mekanizmalarının etkinliği artırılacaktır."
            },
            {
                "policy_no": "1.2",
                "policy": "Nitelikli UDY profillerinin ihtiyaç duyduğu yatırım yerlerinin çevresel ve sosyal etkiler ile lojistik gereksinimler de dikkate alınarak geliştirilmesi, dijital ortamlarda sunulması ve arazi tahsis süreçlerinin kolaylaştırılması sağlanacaktır."
            },
            {
                "policy_no": "1.3",
                "policy": "Teknoloji girişimciliği ekosisteminin geliştirilmesi amacıyla gerekli fiziksel, hukuki ve dijital altyapı  güçlendirilecek, alternatif ve yenilikçi finansman imkânlarının artırılması sağlanacaktır."
            },
            {
                "policy_no": "1.4",
                "policy": "Nitelikli UDY projelerinin hızla hayata geçmesini teminen bürokratik süreçlerin kolaylaştırılması, dijitalleştirilmesi ve maliyetlerin azaltılması sağlanacaktır."
            },
            {
                "policy_no": "1.5",
                "policy": "İş ve yatırım ortamında düzenleyici çerçeve iyileştirilerek yatırımcı güveni, öngörülebilirlik ve istikrar artırılacaktır."
            },
            {
                "policy_no": "1.6",
                "policy": "Ülkemizdeki uluslararası yatırımcıların faaliyetlerinin derinleştirilmesi, Ar-Ge ve tasarım gibi daha katma değerli alanlara yöneltilmesi ve genişleme türü yatırımlarının artırılması için çalışmalar yürütülecektir."
            },
            {
                "policy_no": "2.1",
                "policy": "Yenilenebilir enerji üretiminin artırılması, iklim ve çevre dostu teknolojilerin yaygınlaştırılması ve yatırımcıların yeşil enerjiye erişiminin kolaylaştırılması sağlanacaktır."
            },
            {
                "policy_no": "2.2",
                "policy": "Ülkemizin yeşil dönüşüm sürecini destekleyecek nitelikli UDY projelerinin çekilebilmesi için döngüsel ekonomi ve sürdürülebilirlik odaklı yatırım ortamı iyileştirme çalışmaları yürütülecektir."
            },
            {
                "policy_no": "2.3",
                "policy": "Başta Avrupa Yeşil Mutabakatı olmak üzere ülkemizin yeşil dönüşüm sürecini destekleyecek uluslararası standartlar ve düzenlemeler takip edilerek üretim ve ticarete yönelik gerekli düzenlemeler hayata geçirilecektir."
            },
            {
                "policy_no": "2.4",
                "policy": "Nitelikli UDY projelerini çekmek amacıyla düşük emisyonlu ve dijital üretim teknikleriyle bütünleşik, çevre dostu politikalar hayata geçirilecektir."
            },
            {
                "policy_no": "2.5",
                "policy": "Enerji verimliliği ve tasarruf potansiyeli yüksek teknolojik yatırımların ülkemize çekilebilmesi için uygun yatırım ortamı sağlanacaktır."
            },
            {
                "policy_no": "2.6",
                "policy": "Türkiye’de yeşil finansmanın gelişimini sağlayacak ve ekosistemin güçlendirilmesine yönelik çalışmalar yürütülecektir."
            },
            {
                "policy_no": "3.1",
                "policy": "Ülkemizin dijital dönüşüm sürecini destekleyecek uluslararası standartlar, veri politikaları ve yasal düzenlemeler takip edilerek üretim ve ticarete yönelik gerekli düzenlemeler hayata geçirilecektir."
            },
            {
                "policy_no": "3.2",
                "policy": "Nitelikli UDY projelerinin ülkemize kazandırılması için ülkemizin fiziksel dijital altyapısı güçlendirilecektir."
            },
            {
                "policy_no": "3.3",
                "policy": "5G ve ötesi yeni nesil iletişim teknolojileri, nesnelerin interneti, yapay zekâ, büyük veri, kuantum, siber güvenlik, blok zincir, akıllı ulaşım, artırılmış gerçeklik gibi gelişen teknoloji alanlarında ekosistemin geliştirilmesi sağlanacaktır."
            },
            {
                "policy_no": "4.1",
                "policy": "Ülkemizin küresel değer zincirlerine entegrasyonunun güçlendirilmesi için yeşil ve dijital dönüşüm alanında uluslararası ticaret politikalarına uyum seviyesi artırılacaktır."
            },
            {
                "policy_no": "4.2",
                "policy": "Ülkemizde ve dünya ticaretinde yaşanan ekonomik gelişmeler göz önünde bulundurularak ülkemizin taraf olduğu ikili ve çok taraflı anlaşmaların (Gümrük Birliği, serbest ticaret anlaşmaları, çifte vergilendirmeyi önleme anlaşmaları vb.) güncellenmesine ve yeni anlaşmaların hayata geçirilmesine yönelik çalışmalar yürütülecektir."
            },
            {
                "policy_no": "4.3",
                "policy": "Türkiye’nin küresel değer zincirlerindeki konumunun güçlendirilmesi amacıyla tüm ulaşım modlarında lojistik kabiliyetleri ve altyapısı çevre ve yeşil dönüşüm hassasiyetleri dikkate alınarak geliştirilecektir."
            },
            {
                "policy_no": "4.4",
                "policy": "Türkiye’deki mevcut uluslararası yatırımcılar ile yerel tedarikçi firmaların iş birlikleri geliştirilerek yerel firmaların küresel değer zincirlerine entegrasyonu artırılacaktır."
            },
            {
                "policy_no": "4.5",
                "policy": "Gümrük işlemlerinde etkinlik ve verimliliğin artırılması amacıyla bilgi ve iletişim teknolojilerinden azami ölçüde yararlanılacak, gümrük hizmetleri yeşil ve dijital dönüşümle uygun bir yapıya kavuşturulacaktır."
            },
            {
                "policy_no": "4.6",
                "policy": "İmalat sektöründeki katma değeri artırmaya yönelik Ar-Ge, Ür-Ge, tasarım, tedarik zinciri yönetimi, dağıtım ve bakım-onarım gibi nitelikli hizmet girdilerinin payının artırılmasına yönelik çalışmalar yapılacaktır."
            },
            {
                "policy_no": "5.1",
                "policy": "Türkiye’nin ikiz dönüşüm çerçevesinde ihtiyaç duyduğu nitelikli beşeri sermayenin geliştirilmesi sağlanacak ve geleceğin mesleklerinin ortaya çıkardığı yeni çalışma modellerine uygun mevzuat çalışmaları yapılacaktır."
            },
            {
                "policy_no": "5.2",
                "policy": "STEM (fen, teknoloji, mühendislik ve matematik) alanlarında eğitim ve istihdamın artırılmasını sağlayacak programlar geliştirilecek ve nitelikli UDY profillerinin ihtiyaç duyduğu yetkin Ar-Ge personelinin yetiştirilmesi sağlanacaktır."
            },
            {
                "policy_no": "5.3",
                "policy": "Nitelikli UDY profillerinin ihtiyaç duyduğu insan kaynağının mesleğe özgü yabancı dil becerilerinin geliştirilmesine yönelik çalışmalar yürütülecektir."
            },
            {
                "policy_no": "5.4",
                "policy": "Nitelikli UDY profillerinin ihtiyaç duyduğu teknik insan kaynağının yetiştirilmesi amacıyla mesleki eğitim kalitesinin ve itibarının artırılmasına yönelik çalışmalar yapılacak; mesleki ve teknik eğitim alan bireylerin işgücü piyasasına geçişleri kolaylaştırılacaktır."
            },
            {
                "policy_no": "5.5",
                "policy": "Türkiye’nin insan kaynakları alanında uluslararası görünürlüğünün artırılması, yurtdışındaki nitelikli insan kaynağının ülkeye çekilmesi ve mevcut yeteneklerin elde tutulması için hedef odaklı çalışmalar yürütülecektir."
            },
            {
                "policy_no": "5.6",
                "policy": "İşgücüne dâhil olmayan nüfusun ekonomide aktif hale gelmesi amacıyla kadın ve gençler başta olmak üzere işgücüne katılımın teşvik edilmesine yönelik çalışmalar yürütülecektir."
            },
            {
                "policy_no": "6.1",
                "policy": "360 derece iletişim yaklaşımı benimsenerek yatırım diplomasisi, uluslararası kampanyalar ve medya ilişkileri vb. gibi araçlarla ülkemizin yatırım ortamı aktif bir şekilde tanıtılacaktır."
            },
            {
                "policy_no": "6.2",
                "policy": "“Invest in Türkiye” markasının güçlendirilmesine, hedef kitlelere yönelik etkili mesajların “Türkiye Yüzyılı, yatırımların Yüzyılı” vizyonuna uygun şekilde geliştirilmesine ve etkili iletişiminin yapılmasına yönelik çalışmalar yapılacaktır."
            },
            {
                "policy_no": "6.3",
                "policy": "Ülkemizdeki yatırım fırsatlarını tanıtan özelleştirilmiş içerikler, materyaller, hedef kitleye yönelik etkinlikler ve dijital kampanyalar yoluyla nitelikli UDY profilleri özelinde tanıtım faaliyetleri yürütülecektir."
            },
            {
                "policy_no": "6.4",
                "policy": "Strateji kapsamında tanımlanan nitelikli UDY profillerine uygun hedef yatırımcılar belirlenerek bu yatırımcılara yönelik yatırım çekme faaliyetleri yürütülecektir."
            },
            {
                "policy_no": "6.5",
                "policy": "Ulusal ve uluslararası tüm paydaşlarla stratejik iletişim çerçevesinde iş birlikleri geliştirilerek ülkemizin iletişim ve tanıtım faaliyetleri güçlendirilecektir."
            }
        ],
        "policy_areas": [
            {
                "area_no": "1",
                "policy_area": "Yatırım Ortamı Rekabetçiliği",
                "imgSrc": "/images/66b262cebe6aa1fd8866d805_qualified_investment.png"
            },
            {
                "area_no": "2",
                "policy_area": "Yeşil Dönüşüm",
                "imgSrc": "/images/66b262e1378812f97c95e929_05.png"
            },
            {
                "area_no": "3",
                "policy_area": "Dijital Dönüşüm",
                "imgSrc": "/images/66b262f88aeec805f8c89cee_08.png"
            },
            {
                "area_no": "4",
                "policy_area": "Küresel Tedarik Zinciri",
                "imgSrc": "/images/66b263055dc4a30bfe69fee9_01.png"
            },
            {
                "area_no": "5",
                "policy_area": "Nitelikli İnsan Kaynağı",
                "imgSrc": "/images/66b2631df1f52b5ef87174d1_new-centers2.png"
            },
            {
                "area_no": "6",
                "policy_area": "İletişim ve Tanıtma",
                "imgSrc": "/images/66b263d68aeec805f8c937fb_Communications%20Promo%20Icon.png"
            }
        ]
    },
    "headerMenu": {
        "currentLanguage": {
            "code": "TR",
            "icon": ""
        },
        "optionalLanguages": [
            {
                "code": "EN",
                "label": "English",
                "icon": "",
                "link": "/en"
            }
        ],
        "menuItems": [
            {
                "name": "ANA SAYFA",
                "link": "/",
                "icon": null
            },
            {
                "name": "UDY GÖRÜNÜMÜ",
                "link": "/insights",
                "icon": null
            },
            {
                "name": "EYLEM PLANI",
                "link": "/action-plans",
                "icon": null
            }
        ],
        "mobileMenuButton": {
            "icon": "",
            "label": "Menü"
        },
        "downloadButton": {
            "text": "PDF İndir",
            "link": "https://www.invest.gov.tr/en/Documents/turkiye-udy-stratejisi-2026-yili-eylem-plani.pdf?download",
            "icon": ""
        }
    },
    "form": {
        "placeholder": "E-posta adresiniz..",
        "submitText": "Başlayın",
        "successMessage": "Teşekkürler! Gönderiminiz alındı!",
        "errorMessage": "Form gönderilirken bir sorun oluştu."
    },
    "footerMenu": {
        "logoLink": "/",
        "downloadPdf": {
            "text": "PDF İndir",
            "link": "https://www.invest.gov.tr/tr/library/publications/lists/investpublications/turkiye-uluslararasi-dogrudan-yatirim-stratejisi-2024-2028.pdf",
            "icon": ""
        },
        "menuItems": [
            {
                "title": "ANA SAYFA",
                "link": "/"
            },
            {
                "title": "UDY ANALİZLERİ",
                "link": "/insights",
                "subLinks": [
                    {
                        "title": "UDY Görünümü ve Eğilimler",
                        "link": "/insights#fdi-outlook"
                    },
                    {
                        "title": "Performans & Ekosistem",
                        "link": "/insights#fdi-performance"
                    },
                    {
                        "title": "Ana Bulgular",
                        "link": "/insights#key-findings"
                    },
                    {
                        "title": "Nitelikli UDY",
                        "link": "/insights#quality-fdi"
                    }
                ]
            }
        ],
        "actionPlan": {
            "title": "EYLEM PLANLARI",
            "link": "/action-plans"
        }
    }
}